import {hot} from 'react-hot-loader/root'
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QualityCheckAnswerList from 'dashboard/qualityChecks/components/QualityCheckAnswerList';
import {displayCustomDialog} from 'util/Utils';
import classNames from 'classnames';
import {
    makeRequest,
    dispatchAction,getErrorMessage,
    displayMessage
} from 'actions';
import {
    Row,
    Col,
    Form,
    FormGroup,
    Tooltip,
    OverlayTrigger,
    Checkbox,
    Modal,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';

import Select   from 'react-select'
import CreatableSelect from 'react-select/lib/Creatable';
import {
    FETCH_ADMIN_GBG_PRODUCTS,
    CLEAR_SELECTED_GBG_PRODUCTS,
    ADD_SELECTED_GBG_PRODUCTS,
    DELETE_ADMIN_GBG_PRODUCT, ADD_ADMIN_GBG_PRODUCT,
    UPDATE_ADMIN_GBG_PRODUCT,
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList, deleteImagesFromS3} from 'util/Utils';
import AdminGBGProductListTable from 'dashboard/GBG_products/AdminGBGProductListTable';
import {GBGProductQualityChecksComponent } from 'dashboard/GBG_products/components/GBGProductQualityChecksComponent';

import AdminGBGProductSearchBox from 'dashboard/GBG_products/AdminGBGProductSearchBox'
import AdminGBGProductsActionsBox from 'dashboard/GBG_products/AdminGBGProductsActionsBox'
import {v4 as uuidv4}  from 'uuid'
import { getVariationOptions , displayVariationsSortingToggle}  from 'shared/sharedMethods';
 import {
     onQualityChecksToIncludeChange,displayQualityCheckItemImages,
    displayButtonToLinkQualityCheckToImage,updateCurrentQualityCheckToInclude,displayVariationOptionEditForm,
  } from "dashboard/GBG_products/GBGProductPageSharedMethods";


import RemoveModalDialog from'shared/RemoveModalDialog';
import ImageList   from 'shared/ImageList'
import FaCheckCircle from 'react-icons/lib/fa/check-circle-o';
import TIWarning from  'react-icons/lib/ti/warning-outline';
const tooltip = (
    <Tooltip className="in" id="tooltip-top">
        Add to title
    </Tooltip>
);
const tooltipAddTag = (
    <Tooltip className="in" id="tooltip-top">
        Add tag
    </Tooltip>
);
import config from  '../../../config';
import _  from 'lodash';
import { getAllowedAgeGroups, removeInvalidAgeGroups } from '../../shared/sharedMethods';

export class AdminGBGProductsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
            currentRecord: {},
            errors: {},
            allCategories: [],
            currentRecordCategoriesList: [],
            currentRecordSubcategoriesList: [],
            // customVariationTypeOptions: [],
            customVariationTypeValue: '',
            customVariationTypeLabel: '',
            customVariationTypeGBGNote: '',
            addCustomVariationType: '',
            currentVariationItemIndex: '',
            allBrands: [],


        };
        this.searchBox = false;
    };

    componentWillMount() {

        this.props.makeRequest({}, {
            'endpoint': '/categories',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allCategories: response.data.data,
                currentRecordCategoriesList: _.map(prepareSelectOptionsList(
                    _.filter(response.data.data, function (category) {
                        return category.AncestorCategories.length == 0
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id',
                    }), function (item) {
                    return {value: uuidv4(), originalID: item.value, label: item.label}
                })

            })

        })
        this.props.makeRequest({'type': 'CategoryTagsList'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allCategoryTags: _.map(_.get(response.data, 'data', []).sort(), item => {
                    return {'value': item, 'label': item}
                })
            })
        }).catch(err => {
        });
        this.props.makeRequest({'Statuses': ['Active'], all: true}, {
            "endpoint": "/quality-checks",
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allQualityChecks: _.orderBy(_.map(_.get(response.data, 'data', []), item => {
                    return {'value': item.ItemNumber, 'label': item.Text}
                }), function (item) {
                    return item.label
                }, ['asc'])
            })
        }).catch(err => {
        });
        this.props.makeRequest({'type': 'GBGProductTagsList'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allGBGProductTags: _.orderBy(_.map(_.get(response.data, 'data', []), item => {
                    return {'value': item.value, 'label': item.label, conditions: _.get(item, 'conditions', [])}
                }), function (item) {
                    return item.label
                }, ['asc'])
            })
        }).catch(err => {
        });
        this.props.makeRequest({'type': 'getAllBrands'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allBrands: _.map(_.get(response.data, 'data', []).sort(), item => {
                    return {'value': item, 'label': item}
                })
            })
        }).catch(err => {
        });

    }
    getUPCCodes(queryParams){
      return this.props.makeRequest(queryParams, {
            "endpoint": "/upc_codes",
            'not_display_success_message': true,
        }).then((res) => {
            return res.data
        })
    }
    addUPCCodeCallback(upcCodeRecord){
        const self = this;

        const foundItemIndex = _.findIndex(self.state.currentRecord.UPCCodes, function (item) {
            return item.value ==  upcCodeRecord.UPCCode
        })
        if(foundItemIndex !== -1) {
            let UPCCodeToUpdate = self.state.currentRecord.UPCCodes[foundItemIndex]
            UPCCodeToUpdate._id = upcCodeRecord._id
            self.setState({
                currentRecord: {
                    currentUPCCodeItem:UPCCodeToUpdate,
                    ...this.state.currentRecord,
                    'UPCCodes': [...self.state.currentRecord.UPCCodes.slice(0, foundItemIndex),
                        UPCCodeToUpdate,
                        ...self.state.currentRecord.UPCCodes.slice(foundItemIndex + 1)]
                }
            })

        }
    }
    addUPCCode(UPCCodeData){

       return this.props.makeRequest(UPCCodeData, {
            "endpoint": "/upc_codes",
           'not_display_error_message': true,
            type: 'post',
            'not_display_success_message': true,
        }).then((res) => {
           return res.data
        }).catch(err => {
            return Promise.reject(err)
       })


    }
    updateUPCCode(UPCCodeToUpdate){
        const self = this;
       return this.props.makeRequest(UPCCodeToUpdate, {
            "endpoint": "/upc_codes"+ '/' + encodeURIComponent(UPCCodeToUpdate._id),
            type: 'patch',
            'not_display_success_message': true,
        }).then((res) => {
            self.props.displayMessage({
                'messageCode': 'UPC code updated',
            });
             return res.data
        })
    }
    deleteUPCCode(UPCCodeToDelete){
        const self = this;
         this.props.makeRequest({}, {
            "endpoint": "/upc_codes"+ '/' + encodeURIComponent(UPCCodeToDelete._id),
            type: 'delete',
            'not_display_success_message': true,
        }).then((res) => {
             self.props.displayMessage({
                'messageCode': 'UPC code deleted',
            });
        }).catch(err => {
                self.setState({
                    currentRecord: {
                        ...this.state.currentRecord,
                        'UPCCodes': [...self.state.currentRecord.UPCCodes.concat([UPCCodeToDelete])]
                    }
                })

        });
    }
    editRecord(row) {
        const self = this;
        // added a return for testing purposes, this function still works as expected
        return this.props.makeRequest({lookup:'UPCCodes',sortBy:'createdAt : 1', recordIDs:[row._id]}, {
            "endpoint": "/gbg_products",
        }).then(function (res) {
            row = res.data.data[0]
            let availableCategories = [];
            _.forEach(_.get(row, ['Categories'], []), function (savedCategory) {
                let foundCategory = _.find(this.state.allCategories, function (category) {
                    return category.AncestorCategories.length == 0 && savedCategory.Category == category.TagName
                }.bind(this))
                let foundSubcategory = _.find(this.state.allCategories, function (category) {
                    return category.AncestorCategories.length > 0 && savedCategory.Subcategory == category.TagName
                }.bind(this))
                if (foundCategory && (!savedCategory.Subcategory || foundSubcategory)) {
                    availableCategories.push({...savedCategory, originalID: foundCategory._id, value: uuidv4()})
                }
            }.bind(this))
            let lastCategory = _.last(availableCategories)
            let foundCategory = _.find(this.state.allCategories, function (category) {
                return category.AncestorCategories.length == 0 && lastCategory && lastCategory.Category == category.TagName
            }.bind(this))

            let foundSubcategory = _.find(this.state.allCategories, function (category) {
                return category.AncestorCategories.length > 0 && lastCategory && lastCategory.Subcategory == category.TagName
            }.bind(this))

            if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), foundCategory._id)) {
                foundSubcategory = undefined;
            }

            let currentRecordSubcategoriesList = [];

            if (foundCategory) {
                currentRecordSubcategoriesList = _.sortBy(prepareSelectOptionsList(
                  _.filter(this.state.allCategories, function (category) {
                      return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), foundCategory._id)
                  }),
                  {
                      label: 'CategoryName',
                      value: '_id'
                  }), 'label')
            }
            const {UPCCodes = []} = row
            let currentRecord = {
                ...row,
                sortVariationOptions:'asc',
                ASIN: _.get(row, 'OriginalProductData.ASIN'),
                RetailProductPrice: _.get(row, 'OriginalProductData.RetailProductPrice'),
                Weight: _.get(row, 'OriginalProductData.Weight'),
                Height: _.get(row, 'OriginalProductData.Height'),
                Width: _.get(row, 'OriginalProductData.Width'),
                Length: _.get(row, 'OriginalProductData.Length'),
                CategoryTags: _.map(row.CategoryTags, function (tag) {
                    return {value: tag, label: tag};
                }),
                UPCCodes: UPCCodes.map(function (item) {
                    return {...item, value: item.UPCCode, label: item.UPCCode}
                }),
                QualityChecksToInclude: _.filter(_.map(_.get(row, 'QualityChecksToInclude', []), function (item) {
                    if (item.ItemNumber) {
                        return {
                            ..._.find(self.state.allQualityChecks, {value: item.ItemNumber}),
                            QualityCheckRules: _.get(item, 'QualityCheckRules', []),
                            ItemNumber: item.ItemNumber
                        }
                    } else {
                        return {
                            value: uuidv4(),
                            customQualityCheck: true,
                            QualityCheckRules: _.get(item, 'QualityCheckRules', []),
                            DeterministicQualityCheck:item.DeterministicQualityCheck || {},
                            originalItemText: item.Text,
                            label: item.Text
                        }
                    }
                }), item => {
                    return _.get(item, 'value')
                }),
                QualityChecksToExclude: _.filter(_.map(_.get(row, 'QualityChecksToExclude', []), function (item) {
                    return {
                        ..._.find(self.state.allQualityChecks, {value: item}),
                        ItemNumber: item
                    }
                }), item => {
                    return _.get(item, 'value')
                }),
                QualityChecksMatchingRules: {
                    ..._.get(row, 'QualityChecksMatchingRules', {}),
                    SellerInventoryOwnership: _.map(_.get(row, 'QualityChecksMatchingRules.SellerInventoryOwnership', []), item => {
                        return _.find(config.inventoryOwnershipMap, {value: item})
                    })
                },

                GBGProductTags: _.map(row.GBGProductTags, function (tag) {
                    var foundGBGProductTag = _.find(self.state.allGBGProductTags, item => {
                        return item.value == tag
                    })
                    if (foundGBGProductTag) {
                        return {value: foundGBGProductTag.value, label: foundGBGProductTag.label};
                    } else {
                        return {value: tag, label: tag};
                    }
                }),
                Categories: availableCategories,
                Variations: _.isUndefined(row.Variations) ? [] : row.Variations,

            }
            var boxSizeTag = _.find(_.get(row, 'GBGProductTags', []), function (tag) {
                return _.includes(tag, 'Box_')
            })

            if (boxSizeTag) {
                currentRecord.selectedBoxSize = boxSizeTag.substring(4)
                if (!_.includes(boxSizeTag, 'Mailer')) {
                    var dimensions = _.split(boxSizeTag.substring(4), 'x')
                    if (_.get(row, 'OriginalProductData.OriginalProductCustomData.BoxSizeHeightResized')) {
                        currentRecord.resizedBoxHeight = _.get(row, 'OriginalProductData.OriginalProductCustomData.BoxSizeHeightResized')
                    } else {
                        currentRecord.resizedBoxHeight = dimensions.length == 3 ? dimensions[2] : ''
                    }
                }

            }

            // this try catch block is used for testing purposes
            // without it the function fails while trying to set the state and doesn't return anything
            // this doesn't effect the actual functionality of the function
            try {
                this.setState({
                    currentRecordSubcategoriesList: currentRecordSubcategoriesList,
                    showModal: true,
                    currentRecord: currentRecord
                });
            } catch {
                return currentRecord;
            }
        }.bind(this))
    }

    UPCCodeValueRenderer(option) {
        const {currentUPCCodeItem = {}} = this.state.currentRecord
        const {VariationLinks = []} = option
        let itemStyle ={}
         if(currentUPCCodeItem.value == option.value){
               itemStyle.fontWeight ='bold'
        }
        return <div>
            <div style={itemStyle}>{option.label + (option.ItemNumber ? ' #' + option.ItemNumber : '')}</div>
            {VariationLinks.length > 0 &&
              <div className="pleft10">
                  {VariationLinks.map((variationLink, index) => {
                      return <div style={{
                          position: 'relative',
                          maxWidth: 200,
                          lineHeight: '23px',
                          borderTop: '1px solid gray'
                      }} className="top10 ptop10 pright25" key={index}>{variationLink.VariationLabel + ' - ' + variationLink.VariationOptionLabel}

                      </div>
                  })
                  }
              </div>
            }
        </div>
    }

    onUPCCodeClick(option) {
        // let selectedOption = {...option}
        // const {selectedUPCCode = {}} = this.state.currentRecord
        // if (selectedUPCCode.value == selectedOption.value) {
        //     selectedOption = {}
        // }

        this.setState({
            currentRecord: {
                ...this.state.currentRecord,
                currentUPCCodeItem: {
                    ...option,
                    display: true
                }
            }
        })
    }




    onQualityChecksToIncludeClick(option) {
        this.setState({
            currentRecord: {
                ...this.state.currentRecord,
                currentQualityCheckItem: {
                    ...option,
                    display: true
                }
            }
        })
    }

    renderQualityCheckOptions(option) {

        return (
            <div  >
                <div>{option.label + (option.ItemNumber ? ' #' + option.ItemNumber : '')}</div>

            </div>
        );
    }

    renderQualityCheckValues(option) {
        const {currentQualityCheckItem = {}} = this.state.currentRecord

        let itemStyle ={}
        if(currentQualityCheckItem.value == option.value){
            itemStyle.fontWeight ='bold'
        }
          return (
            <div  >
                <div style={itemStyle}>{option.label + (option.ItemNumber ? ' #' + option.ItemNumber : '')}</div>

            </div>
        );
    }

    renderCategoriesValue(option) {
        return (
            <div>
                <div>{option.Category}</div>
                <div>{option.Subcategory}</div>
            </div>
        );
    }

    onSubcategoryFormChange(option) {
        var lastSelectedCategory = _.find(this.state.allCategories, function (category) {
            return _.last(this.state.currentRecord.Categories).originalID == category._id
        }.bind(this))
        var foundSubcategory = _.find(this.state.allCategories, function (category) {
            return category.AncestorCategories.length > 0 && option.value == category._id
        }.bind(this))
        if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)) {
            foundSubcategory = undefined;
        }
        if (foundSubcategory) {
            this.setState({
                'currentRecord': {
                    ...this.state.currentRecord,
                    Categories: [...this.state.currentRecord.Categories.slice(0, _.size(this.state.currentRecord.Categories) - 1),
                        {..._.last(this.state.currentRecord.Categories), Subcategory: foundSubcategory.TagName},
                        ...this.state.currentRecord.Categories.slice(_.size(this.state.currentRecord.Categories))],
                }
            })
        }


    }

    onCategoryFormChange(options) {
        var clearSubcategoryValue = false;
        var Categories = [...this.state.currentRecord.Categories]
        var lastSelectedCategory = _.find(this.state.allCategories, function (category) {
            return _.last(options) && _.last(options).originalID == category._id
        }.bind(this))
        if (options.length > Categories.length) { /* when new option is selected */
            Categories.push({
                ... _.last(options),
                value: uuidv4(),
                Category: lastSelectedCategory.TagName,
                originalID: _.last(options).originalID
            })

        } else if (options.length < Categories.length) { /* value is removed */
            var deletedOption = _.differenceWith(Categories, options, function (item1, item2) {
                return ( item1.Category === item2.Category && item1.value === item2.value && ((!item1.Subcategory && !item2.Subcategory) || item1.Subcategory === item2.Subcategory))
            });
            /* returns difference between first   and second arrays*/

            _.remove(Categories, function (item) {
                if (item.Category == deletedOption[0].Category && ((!item.Subcategory && !deletedOption[0].Subcategory) || item.Subcategory === deletedOption[0].Subcategory)) {
                    return true;
                }
            })

        }
        if (lastSelectedCategory) { /* change options for Subcategories */

            var currentRecordSubcategoriesList = _.sortBy(prepareSelectOptionsList(
                _.filter(this.state.allCategories, function (category) {
                    return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)
                }),
                {
                    label: 'CategoryName',
                    value: '_id'
                }), 'label')
            /* check if currently selected subcategory belongs to the selected category*/
            if (this.state.Subcategory) {
                var foundSubcategory = _.find(this.state.allCategories, function (category) {
                    return this.state.Subcategory == category._id
                }.bind(this))
                if (foundSubcategory && !_.includes(_.map(foundSubcategory.AncestorCategories, 'CategoryID'), lastSelectedCategory._id)) {
                    clearSubcategoryValue = true;
                }
            }

        }

        this.setState({
            currentRecordSubcategoriesList: currentRecordSubcategoriesList,
            Subcategory: clearSubcategoryValue ? '' : this.state.Subcategory,
            'currentRecord': {
                ...this.state.currentRecord,
                Categories: Categories,

            },
            currentRecordCategoriesList: _.map([...this.state.currentRecordCategoriesList], function (item) {
                return {value: uuidv4(), originalID: item.originalID, label: item.label}
            })
        })

    }

    addVariation() {
        this.setState({
            currentRecord: {
                ...this.state.currentRecord,
                Variations: this.state.currentRecord.Variations.concat({
                    newVariationOption: true,
                    Label: '',
                    InputType: 'select',
                    Options: [],
                    AddTag: true
                })
            }
        });
    }

    addUpdateVariationOption() {
        const self = this;
        const currentVariationItemIndex = this.state.currentVariationItemIndex
        const currentVariationOptionIndex = this.state.currentVariationOptionIndex
        if (this.state.customVariationTypeValue == '' || this.state.customVariationTypeLabel == '') {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Option label and value are required',
            });
        }

        let updatedOptions = []

        if (currentVariationOptionIndex == -1) {
            updatedOptions = _.concat(_.get(this.state.currentRecord.Variations, [currentVariationItemIndex, 'Options'], []), [{
                value: this.state.customVariationTypeValue,
                label: this.state.customVariationTypeLabel,
                CustomGBGNote: this.state.customVariationTypeGBGNote
            }])
        } else { /* update existing option */
            updatedOptions = [...this.state.currentRecord.Variations[currentVariationItemIndex].Options.slice(0, currentVariationOptionIndex),
                {
                    value: this.state.customVariationTypeValue,
                    label: this.state.customVariationTypeLabel,
                    CustomGBGNote: this.state.customVariationTypeGBGNote
                },
                ...this.state.currentRecord.Variations[currentVariationItemIndex].Options.slice(currentVariationOptionIndex + 1)];
        }
        let updateVariationParams = {}
        const variationRecord = this.state.currentRecord.Variations[this.state.currentVariationItemIndex]
        const originalOptionItem = variationRecord.Options[this.state.currentVariationOptionIndex]
        let stateData = {
            currentVariationItemIndex: '',
            currentVariationOptionIndex: '',
            customVariationTypeLabel: '',
            customVariationTypeValue: '',
            customVariationTypeGBGNote: '',
        }
        this.onVariationOptionsChange({
            variationIndex: currentVariationItemIndex, options: updatedOptions, callback: () => {
                console.log('originalOptionItem', originalOptionItem  );
                if (originalOptionItem) {
                    let UPCCodes = self.getLInkedUPCCodesToUpdate(variationRecord, originalOptionItem, false)
                    console.log('UPCCodes', UPCCodes  );
                    let UPCCodesToUpdate = UPCCodes.filter(item => {
                        return item.itemToUpdate
                    })
                    if (UPCCodesToUpdate.length) {
                        updateVariationParams.UPCCodesToUpdate = UPCCodesToUpdate.map(item => {
                            return {recordID: item._id, VariationLinks: item.VariationLinks}
                        })
                    }
                    self.saveVariations(updateVariationParams).then(() => {

                        if (UPCCodesToUpdate.length) {
                            stateData.currentRecord = {
                                ...self.state.currentRecord,
                                'UPCCodes': UPCCodes
                            }
                        }
                        self.setState(stateData);
                    })
                } else {
                    self.setState(stateData);
                }
            }
        })

    }
    getLInkedUPCCodesToUpdate(variationRecord,optionToCheck, deleteOption){
        const self = this;
        const {UPCCodes =[]} =  _.cloneDeep(this.state.currentRecord)
         UPCCodes.forEach(UPCCode=> {
             UPCCode.itemToUpdate = false;
            const {VariationLinks =[]} = UPCCode
              VariationLinks.forEach(variationLink=>{
                 if(optionToCheck){
                  if(variationLink.VariationLabel == variationRecord.Label && variationLink.VariationOptionLabel == optionToCheck.label &&  variationLink.VariationOptionValue == optionToCheck.value  ) {
                      UPCCode.itemToUpdate = true;
                      if (deleteOption) {
                          variationLink.linkToDelete = true
                      } else {
                          variationLink.VariationLabel = variationRecord.Label
                          variationLink.VariationOptionLabel = self.state.customVariationTypeLabel
                          variationLink.VariationOptionValue = self.state.customVariationTypeValue
                      }
                  }
                 } else {
                     const labelToCheck = variationRecord.OriginalLabel ? variationRecord.OriginalLabel : variationRecord.Label
                     if (variationLink.VariationLabel == labelToCheck) {
                         UPCCode.itemToUpdate = true;
                         if (deleteOption) {
                             variationLink.linkToDelete = true
                         } else {
                             variationLink.VariationLabel = variationRecord.Label
                         }
                     }
                 }
            })
           UPCCode.VariationLinks = VariationLinks.filter(item=>{
               return  !item.linkToDelete
           })
        })
        return UPCCodes
    }
    onVariationSelectValueClick(variationIndex, option) {

       const foundVariationOptionIndex = _.findIndex(this.state.currentRecord.Variations[variationIndex].Options, function (optionItem) {
             return optionItem.label == option.label && optionItem.label  ==option.label
         })
         this.setState({
            currentVariationItemIndex: variationIndex,
            currentVariationOptionIndex:foundVariationOptionIndex,
            customVariationTypeLabel: option.label,
            customVariationTypeValue: option.value,
            customVariationTypeGBGNote: _.get(option, 'CustomGBGNote', '')
        })
    }

    renderVariationSelectValue(option) {
        let itemStyle ={}
        const {customVariationTypeValue,customVariationTypeLabel } = this.state
        if(customVariationTypeValue == option.value && customVariationTypeLabel == option.label ){
            itemStyle.fontWeight ='bold'
        }
        return (
            <div>
                <div  style={itemStyle}>{option.label + (option.CustomGBGNote ? ' *' : '')}</div>
            </div>
        );
    }



    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
            currentVariationItemIndex: '',
            currentVariationOptionIndex: '',
            customVariationTypeLabel: '',
            customVariationTypeValue: '',
            customVariationTypeGBGNote: '',
        });
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: {recordIDToDelete:row._id}});
    }

    addNewGBGProduct() {
        this.setState({
            showModal: true,
            currentRecord: {
                Category: '',
                Subcategory: '',
                Categories: [],
                Brand: '',
                Model: '',
                Note: '',
                MostWantedProductPayoutPercentage: null,
                ActiveMostWantedGBGProduct: false,
                Variations: [],
            },

        });
    }

    setGBGProductAsDeleted() {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'patch',
            "endpoint": "/gbg_products/setAsDeleted/" + encodeURIComponent(this.state.currentRecord.recordIDToDelete),
            'success_event': DELETE_ADMIN_GBG_PRODUCT,
            'success_event_data': {
                'recordID': this.state.currentRecord.recordIDToDelete
            },
            messageData: {'#1#': 'GBG product'},
            messageCode: 'recordSetAsDeleted',
        };
        this.setState({currentRecord: {}});
        this.props.makeRequest({}, methodData).then(function () {

        }).catch(err => {

        });
    }

    validateAndGetFormData() {
        let formData = _.pick(this.state.currentRecord, ['Type', 'AgeGroups', 'GBGNote', 'CustomNote', 'Categories', 'Brand', 'Model', 'ActiveMostWantedGBGProduct']);
        let dataNotValid = false;
        const currentRecord = _.cloneDeep(this.state.currentRecord);
        const {matchingQualityChecksOrder = []} = currentRecord;
        formData.Variations = _.map(_.get(this.state.currentRecord, 'Variations', []), item => {
            var itemToSave = {...item}
            if (item.InputType !== 'select') {

                itemToSave.VariationImages = []
            }
            return itemToSave
        })

        if (formData['ActiveMostWantedGBGProduct'] == true) {
            const {MostWantedProductPayoutPercentage} = this.state.currentRecord;

            if (!(MostWantedProductPayoutPercentage > 0 && MostWantedProductPayoutPercentage <= 100)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Set Payout Percentage a value between 0.1 and 100 or unmark the most wanted product.',
                });
                dataNotValid = true;
                return false;
            }

            formData.MostWantedProductPayoutPercentage = MostWantedProductPayoutPercentage;
        }

         _.forEach(['Brand', 'Model', 'Note'], function (requiredField) {
             if (formData[requiredField] == '') {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': requiredField + ' field is required',
                });
                dataNotValid = true;
                return false;
            }
        }.bind(this))

        if(!_.isUndefined(currentRecord.UPCCodes)) {
            formData['UPCCodes'] = currentRecord.UPCCodes.map(item => {
                const {VariationLinks = []} = item
                return {
                    UPCCode: item.value,
                    newUPCCode: item.UPCCodeID ? false : true,
                    VariationLinks: VariationLinks
                }
            })
        }

        if(matchingQualityChecksOrder.length) {
           formData['MatchingQualityChecksOrder']  =  matchingQualityChecksOrder;
       }
        formData['QualityChecksToExclude'] = _.map(_.get(currentRecord, 'QualityChecksToExclude', []), 'value')
        formData['QualityChecksMatchingRules'] =  _.get(currentRecord, 'QualityChecksMatchingRules', {}),
        formData['QualityChecksMatchingRules'].SellerInventoryOwnership = _.map(_.get(currentRecord, 'QualityChecksMatchingRules.SellerInventoryOwnership', []), 'value')
        formData['QualityChecksToInclude'] = _.map(_.get(currentRecord, 'QualityChecksToInclude', []), item => {


            if (item.customQualityCheck) {
                const {DeterministicQualityCheck  = {}} = item;
                return {Text: item.label, QualityCheckRules: item.QualityCheckRules, DeterministicQualityCheck};
            } else {
                return {ItemNumber: item.value,
                    QualityCheckRules: _.get(item, 'QualityCheckRules')}
            }
        })
        formData['CategoryTags'] = _.map(_.get(currentRecord, 'CategoryTags', []), 'value')
        formData['GBGProductImagesToSet'] = _.get(currentRecord, 'GBGProductImages', [])
        formData['GBGProductTags'] = _.map(_.get(currentRecord, 'GBGProductTags', []), 'value')


        if(this.state.currentRecord.selectedBoxSize) {
            //   var boxSizeTag  =  _.find( formData['GBGProductTags'], function (tag) {   return _.includes(tag, 'Box_')   })
            //    if (boxSizeTag){
            formData['GBGProductTags'] = _.reject(formData['GBGProductTags'], tag => {
                return _.includes(tag, 'Box_')
            })
            //      }
            formData['GBGProductTags'] = _.concat(formData['GBGProductTags'], ['Box_' + this.state.currentRecord.selectedBoxSize])
            if (!_.isUndefined(this.state.currentRecord.boxSizeConfirmed)) {
                if (this.state.currentRecord.boxSizeConfirmed) {
                    //   if (!_.get(this.state.currentRecord, 'OriginalProductData.OriginalProductCustomData.BoxSizeConfirmed')) {
                    _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeConfirmed', this.state.currentRecord.selectedBoxSize)
                    formData['GBGProductTags'].push('Shipping Options_Shippable')
                    //    }

                } else {
                    _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeConfirmed', 'unset')

                }
            }

            if( this.state.currentRecord.resizedBoxHeight) {
                if (_.includes(this.state.currentRecord.selectedBoxSize,'Mailer')){
                    _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeHeightResized',  'unset')
                } else {
                    if (isNaN(this.state.currentRecord.resizedBoxHeight)) {
                        this.props.displayMessage({
                            'messageType': 'warning',
                            'messageCode': 'Resize box height is not valid '
                        });
                        dataNotValid = true;
                        return false;
                    }
                    var dimensions = _.split(_.get(this.state.currentRecord, 'selectedBoxSize', ''), 'x')
                    if (dimensions[2] == this.state.currentRecord.resizedBoxHeight) {
                        _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeHeightResized',  'unset')


                    }else{
                        _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeHeightResized',  this.state.currentRecord.resizedBoxHeight)
                    }
                }



            }
        }else   if (!_.isUndefined(this.state.currentRecord.selectedBoxSize)){/*box size is removed*/
            _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeConfirmed',  'unset')
            _.set(formData, 'OriginalProductDataToUpdate.OriginalProductCustomData.BoxSizeHeightResized',  'unset')
        }


        if (!_.isUndefined(this.state.currentRecord.ASIN) && this.state.currentRecord.ASIN !== _.get(this.state.currentRecord, 'OriginalProductData.ASIN')) {
            if (this.state.currentRecord.ASIN !== '' && this.state.currentRecord.ASIN.length !== 10) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'ASIN number must include 10 characters',
                });
                dataNotValid = true;
            }
            _.set(formData, 'OriginalProductDataToUpdate.ASIN', this.state.currentRecord.ASIN)
        }
        if (!_.isUndefined(this.state.currentRecord.Weight) && this.state.currentRecord.Weight !== _.get(this.state.currentRecord, 'OriginalProductData.Weight')) {
            if (isNaN(this.state.currentRecord.Weight) || this.state.currentRecord.Weight < 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify valid Weight value',
                });
                dataNotValid = true;
            }
            const weightToUpdate = this.state.currentRecord.Weight == '' ?  'unset' : this.state.currentRecord.Weight
            _.set(formData, 'OriginalProductDataToUpdate.Weight', weightToUpdate)
        }
        if (!_.isUndefined(this.state.currentRecord.Height) && this.state.currentRecord.Height !== _.get(this.state.currentRecord, 'OriginalProductData.Height')) {
            if (isNaN(this.state.currentRecord.Height) || this.state.currentRecord.Height < 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify valid Height value',
                });
                dataNotValid = true;
            }
            const heightToUpdate = this.state.currentRecord.Height == '' ?  'unset' : this.state.currentRecord.Height
            _.set(formData, 'OriginalProductDataToUpdate.Height', heightToUpdate)
        }
        if (!_.isUndefined(this.state.currentRecord.Width) && this.state.currentRecord.Width !== _.get(this.state.currentRecord, 'OriginalProductData.Width')) {
            if (isNaN(this.state.currentRecord.Width) || this.state.currentRecord.Width < 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify valid Width value',
                });
                dataNotValid = true;
            }
            const widthToUpdate = this.state.currentRecord.Width == '' ?  'unset' : this.state.currentRecord.Width
            _.set(formData, 'OriginalProductDataToUpdate.Width', widthToUpdate)
         }
        if (!_.isUndefined(this.state.currentRecord.Length) && this.state.currentRecord.Length !== _.get(this.state.currentRecord, 'OriginalProductData.Length')) {
            if (isNaN(this.state.currentRecord.Length) || this.state.currentRecord.Length < 0) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify valid Length value',
                });
                dataNotValid = true;
            }
            const lengthToUpdate = this.state.currentRecord.Length == '' ?  'unset' : this.state.currentRecord.Length
            _.set(formData, 'OriginalProductDataToUpdate.Length', lengthToUpdate)
         }
        if (!_.isUndefined(this.state.currentRecord.RetailProductPrice) && this.state.currentRecord.RetailProductPrice !== _.get(this.state.currentRecord, 'OriginalProductData.RetailProductPrice')) {
            if (isNaN(this.state.currentRecord.RetailProductPrice) || this.state.currentRecord.RetailProductPrice < 0 || this.state.currentRecord.RetailProductPrice > 3000) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify valid Retail Price value',
                });
                dataNotValid = true;
            }

            const retailProductPriceToUpdate = this.state.currentRecord.RetailProductPrice == '' ?  'unset' : this.state.currentRecord.RetailProductPrice;
            _.set(formData, 'OriginalProductDataToUpdate.RetailProductPrice', retailProductPriceToUpdate)
         }

        if (_.size(formData.Categories) == 0) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'At least one category must be assigned',
            });
            dataNotValid = true;
        }
        formData['GBGProductTags'] = _.uniq( formData['GBGProductTags'])

        formData['AgeGroups'] = removeInvalidAgeGroups(formData['AgeGroups'])

        if (dataNotValid) {
            return false;
        }
        return formData
    }

    deleteVariationImage(variation, variationIndex, imageToDelete) {
        var imageToDeleteIndex = _.findIndex(variation.VariationImages, {'_id': imageToDelete._id});
        //  if (_.includes(imagesToDelete.URL,'﻿https://s3-')){
        if (imagesToDelete.Type !== 'External') {
            var imagesToDelete = _.concat(_.get(this.state.currentRecord, 'imagesToDelete', []), [imageToDelete.URL])
        } else {
            var imagesToDelete = _.get(this.state.currentRecord, 'imagesToDelete', [])
        }
        this.setState({
            currentRecord: {
                ...this.state.currentRecord,
                imagesToDelete: imagesToDelete,
                Variations: [...this.state.currentRecord.Variations.slice(0, variationIndex),
                    {
                        ...variation,
                        VariationImages: [...variation.VariationImages.slice(0, imageToDeleteIndex),
                            ...variation.VariationImages.slice(imageToDeleteIndex + 1)]
                    },
                    ...this.state.currentRecord.Variations.slice(variationIndex + 1)],
            }
        })
    }



    getQualityChecksForGBGProduct() {
        var self = this;
        var params = {
            all: true,
            includeRecordWithEmptyCategoryTags: true,
            includeRecordWithEmptySellerInventoryOwnership:true
        }
        if (_.size(_.get(this.state.currentRecord, 'CategoryTags', [])) > 0) {
            params.CategoryTags = _.map(_.get(this.state.currentRecord, 'CategoryTags', []), 'value')
        }

        if (_.size(_.get(this.state.currentRecord, ['Categories'], [])) > 0) {
            var GBGProductCategories = []
            _.forEach(_.get(self.state.currentRecord, ['Categories'], []), function (item) {
                var foundTopLevelCategory = _.find(self.state.allCategories, function (categoryRecord) {
                    return categoryRecord.TagName == item.Category
                })

                if (foundTopLevelCategory) {
                    if (item.Subcategory) {
                        var foundSubcategory = _.find(self.state.allCategories, function (category) {
                            return category.AncestorCategories.length > 0 && item.Subcategory == category.TagName
                        }.bind(this))
                        if (foundSubcategory) {
                            GBGProductCategories.push({
                                Category: item.Category,
                                Subcategory: item.Subcategory
                            })

                        }
                    } else {
                        GBGProductCategories.push({Category: item.Category})
                    }
                }
            })

            params.Categories = GBGProductCategories
        }
        params.Brand = _.get(this.state.currentRecord, 'Brand')
        params.Model = _.get(this.state.currentRecord, 'Model')
        if (_.size(_.map(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), 'value'))) {
            params.ItemsNumberToInclude = _.map(_.reject(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), item => {
                return item.customQualityCheck
            }), item=>{
                return {ItemNumber:item.value}
            })
        }

        params.prepareQualityCheckList = true;
        const {QualityChecksToInclude = [], MatchingQualityChecksOrder = []} = this.state.currentRecord;

        if(MatchingQualityChecksOrder.length) {
            params.matchingQualityChecksOrder = MatchingQualityChecksOrder;
        }

        const customQualityChecksToInclude = QualityChecksToInclude.filter(qualityCheck=>_.isUndefined(qualityCheck.ItemNumber));
        if(customQualityChecksToInclude.length) {
            params.customQualityChecksToInclude = customQualityChecksToInclude.map(item=>{return {...item, Text:item.label};});
        }

         params.SellerInventoryOwnership = ['SellerConsigned','PartnerConsigned', 'PartnerPurchased'];
        return this.props.makeRequest(params, {
            'endpoint': '/match_quality_checks',
            type: 'post',
        }).then(res => {
            const firstBaseQualityCheckIndex = res.data.data.findIndex(
             (item) => item.qualityCheckType == 'Base'
            );
             const matchingQualityChecks = res.data.data.filter((item, index)=>{
                if(item.qualityCheckType !== 'Base' ||  firstBaseQualityCheckIndex == index) {
                    return true;
                }
            });
            self.setState({
                currentRecord: {
                    ...self.state.currentRecord,
                    qualityChecksMatchingParams: params,
                    matchingQualityChecks
                }
            })


            return true
        }).catch(err => {
        });

    }

    getAmazonProductDataByASIN() {
        return this.props.makeRequest({ASIN: this.state.currentRecord.ASIN}, {
            'endpoint': '/get-amazon-products',
        }).then(res => {

            if (_.get(res.data, 'data.0', false)) {
                this.setState({
                    currentRecord: {
                        ...this.state.currentRecord,
                        AmazonProductData: _.get(res.data, 'data.0', false),
                    }
                })
            } else {
                this.props.displayMessage({
                    'messageCode': 'Amazon product not found by ASIN ' + this.state.currentRecord.ASIN
                });
            }

            return true
        }).catch(err => {
        });

    }

    deleteImage(imageToDelete) {
        return this.props.makeRequest({GBGProductImagesToDelete: [imageToDelete]}, {
            "endpoint": "/gbg_products/" + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        }).then(res => {
            var imageToDeleteIndex = _.findIndex(_.get(this.state.currentRecord, 'GBGProductImages', []), {'_id': imageToDelete._id});
            this.setState({
                currentRecord: {
                    ...this.state.currentRecord,
                    imagesToDelete: _.concat(_.get(this.state.currentRecord, 'imagesToDelete', []), [imageToDelete.URL]),
                    GBGProductImages: [..._.get(this.state.currentRecord, 'GBGProductImages', []).slice(0, imageToDeleteIndex),
                        ..._.get(this.state.currentRecord, 'GBGProductImages', []).slice(imageToDeleteIndex + 1)],
                }
            })
            this.props.displayMessage({
                'messageCode': 'Image deleted',
            });
            this.search()
            return true
        }).catch(err => {
        });
    }

    saveVariations(customParams) {
         let formData = { GBGProductID : this.state.currentRecord._id}
        let errorMessage = false;
        formData.Variations = this.state.currentRecord.Variations.map(item => {
            var itemToSave = {...item}
            if (item.InputType == 'select') {
               const {Options = []} = item
                if(Options.length ==0){
                  errorMessage = 'Please, add at least one option to this variation'
                }
            }else{
                itemToSave.VariationImages = []
            }
            return itemToSave
        })
        _.extend(formData,customParams)
        if(errorMessage){
              this.props.displayMessage({
                'messageType': 'warning',
                'messageCode':errorMessage
            });
              return Promise.resolve()
        }
       return this.props.makeRequest(formData,  {
            "endpoint": "/gbg_products/" + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
            success_event: UPDATE_ADMIN_GBG_PRODUCT,
            messageData: {'#1#': 'GBG product'},
            messageCode: 'recordUpdated'
        }).then(res => {
           return true;
        });
    }
     saveRecord() {
        var self = this;
        var formData = this.validateAndGetFormData();
        if (!formData) {
            return false;
        }
        var methodData
        if (this.state.currentRecord._id) {
            methodData = {
                "endpoint": "/gbg_products/" + encodeURIComponent(this.state.currentRecord._id),
                type: "patch",
                success_event: UPDATE_ADMIN_GBG_PRODUCT,
                messageData: {'#1#': 'GBG product'},
                messageCode: 'recordUpdated'
            };
        } else {
            if(!_.isUndefined(formData.OriginalProductDataToUpdate)) {
                formData.OriginalProductData = formData.OriginalProductDataToUpdate;
            }
            methodData = {
                "endpoint": "/gbg_products",
                type: "post",
                success_event: ADD_ADMIN_GBG_PRODUCT,
                messageData: {'#1#': 'GBG product'},
                messageCode: 'recordAdded'
            };
        }

        formData.GBGProductID = this.state.currentRecord._id
         this.props.makeRequest(formData, methodData).then(res => {
            if (_.size(_.get(this.state.currentRecord, 'imagesToDelete', []))) {
                deleteImagesFromS3.call(self,_.get(this.state.currentRecord, 'imagesToDelete', []))
            }
            this.setState({
                showModal: false,
                currentRecord: {},
            })


            this.search({page: _.isUndefined(queryString.parse(this.props.location.search).page) ? 1 : parseInt(queryString.parse(this.props.location.search).page)})
        }).catch(err => {
        });

    }

    onSortChange(field, sortOrder) {
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        if (!_.get(this.refs, 'actionsBox.state.doNotClearSelectedRecords', false) && _.isUndefined(params.doNotClearSelectedRecords) && _.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_GBG_PRODUCTS)
        }

        if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            return
        }
        queryParams.addFields = ['QualityChecksNumber']
        if(queryParams.upcCodeText){
            queryParams.lookup = ['UPCCodes']
        }

         _.extend(queryParams, params);

        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary = '_id:-1';
            /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        }
        var methodData = {
            "endpoint": "/gbg_products",
            'not_display_success_message': true,
        };
        if (_.isUndefined(params.include)) {
            methodData['success_event'] = FETCH_ADMIN_GBG_PRODUCTS;
        }
        const stringified = queryString.stringify(_.omit(queryParams, ['include', 'lookup', 'all','addFields', 'sortBySecondary']));
        if (_.isUndefined(params.doNotUpdateUrlString)) {
            this.context.router.push('/admin/gbg-products?' + stringified);
        }
        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            return res;
        }).catch(err => {
            this.setState({pending:false})
        });
    }
    renderCurrentRecordUPCCodes() {
        const self =this;
        const {currentUPCCodeItem={}} = this.state.currentRecord
        const currentUPCCodeItemRecord = this.state.currentRecord.UPCCodes.find(function (image) {
            return image.value == currentUPCCodeItem.value
        })
        const {VariationLinks=[]} = currentUPCCodeItemRecord ? currentUPCCodeItemRecord:{}
        return <div >
            <FormGroup>
            <ControlLabel>UPC Codes</ControlLabel>
            <Row>
                <Col md={10} sm={10} xs={12} className="bot10">
                    <CreatableSelect
                      tabIndex="0"
                      clearable={true}
                      optionRenderer={(option) => {
                          return <div>
                              <div>{option.label + (option.ItemNumber ? ' #' + option.ItemNumber : '')}</div>
                          </div>
                      }}
                      options={this.state.currentRecord.UPCCodes.map(item => {
                          return {value: item.value, label: item.label, ItemNumber: item.value}
                      })
                      }
                      multi
                      placeholder=""
                      removeSelected={false}
                      valueRenderer={this.UPCCodeValueRenderer.bind(this)}
                      onValueClick={(option) => this.onUPCCodeClick(option)}
                      onChange={(selectedOptions) => {
                         const lastOption =_.last(selectedOptions)
                          if(selectedOptions.length > this.state.currentRecord.UPCCodes.length ) {
                              if (lastOption) {/* this is new option*/
                                  const UPCCodeData = {
                                      GBGProductID: this.state.currentRecord._id,
                                      UPCReceivedFrom: 'GBG Product Edit',
                                      UPCCode: lastOption.value
                                  }
                                  self.addUPCCode(UPCCodeData).then(upcCodeRecord => {
                                      self.addUPCCodeCallback(upcCodeRecord)
                                      self.props.displayMessage({
                                          'messageCode': 'UPC code added',
                                      });
                                  }).catch(err => {
                                      self.removeNewOption(UPCCodeData)
                                  })
                              }
                          }else  if(selectedOptions.length < this.state.currentRecord.UPCCodes.length ){
                              const deletedOptions = _.differenceBy( this.state.currentRecord.UPCCodes, selectedOptions,'value')
                               self.deleteUPCCode(deletedOptions[0])
                           }

                           this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  'UPCCodes': selectedOptions
                              }
                          })
                      }}
                      value={this.state.currentRecord.UPCCodes}
                    />
                </Col>
             </Row>
        </FormGroup>
            {(currentUPCCodeItem.display && VariationLinks.length >0) &&
              <Row className="bot25 ">
                     <Col md={4} xs={6} className=" ">
                         {VariationLinks.map((variationLink, index) => {
                             return <div style={{
                                 position: 'relative',
                                 maxWidth: 200,
                                 borderTop: '1px solid gray'
                             }} className="top10 ptop10 pright25" key={index}>{ variationLink.VariationLabel + ' - ' +variationLink.VariationOptionLabel}

                                   <div style={{position: 'absolute', top: 12, right: 0}}
                                        className="delete-button   "
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            const foundItemIndex = _.findIndex(self.state.currentRecord.UPCCodes, function (image) {
                                                return image.value == self.state.currentRecord.currentUPCCodeItem.value
                                            })
                                            const updatedUPCCode = {
                                                ...self.state.currentRecord.UPCCodes[foundItemIndex],
                                                VariationLinks: [...self.state.currentRecord.UPCCodes[foundItemIndex].VariationLinks.slice(0, index),
                                                    ...self.state.currentRecord.UPCCodes[foundItemIndex].VariationLinks.slice(index + 1)]
                                            }
                                            self.updateUPCCode(updatedUPCCode).then(function() {
                                                self.setState({
                                                    currentRecord: {
                                                        ...self.state.currentRecord,
                                                        UPCCodes: [... self.state.currentRecord.UPCCodes.slice(0, foundItemIndex),
                                                            updatedUPCCode,
                                                            ...self.state.currentRecord.UPCCodes.slice(foundItemIndex + 1)]
                                                    }
                                                })
                                            })
                                        }} >
                                   </div>
                             </div>
                         })
                         }
                    </Col>
              </Row>
            }
        </div>
    }
    removeNewOption(UPCCodeData){
        const foundItemIndex = _.findIndex(this.state.currentRecord.UPCCodes, function (item) {
            return item.value == UPCCodeData.UPCCode
        })
        if(foundItemIndex !== -1) {
            this.setState({
                currentRecord: {
                    ...this.state.currentRecord,
                    'UPCCodes': [...this.state.currentRecord.UPCCodes.slice(0, foundItemIndex),
                        ...this.state.currentRecord.UPCCodes.slice(foundItemIndex + 1)]
                }
            })
        }
    }
    renderVariationsUseInTitleConfirmationDialog() {
        return displayCustomDialog.call(this, {
            cancelButtonTitle: 'No',
            buttonTitle: 'Yes',
            dialogContent: () => {
                return (
                    <div>You are about to remove UPC data, are you sure?</div>
                );
            },
            cancelActionHandler: () => {},
            confirmActionHandler: (data) => {
                const self = this;
                const variationIndex = this.state.currentVariationIndex;
                const variation = this.state.currentVariation;

                this.onVariationChange(variationIndex, {
                    ...variation,
                    'UseInTitle': !variation.UseInTitle
                },{callback: ()=>{
                    if(!this.state.currentRecord.Variations[variationIndex].UseInTitle) {
                        let updateVariationParams = {}
                        let UPCCodes = self.getLInkedUPCCodesToUpdate(this.state.currentRecord.Variations[variationIndex], false, true)
                        let UPCCodesToUpdate = UPCCodes.filter(item => {
                            return item.itemToUpdate
                        })
                        if (UPCCodesToUpdate.length) {
                            updateVariationParams.UPCCodesToUpdate = UPCCodesToUpdate.map(item => {
                                return {recordID: item._id, VariationLinks: item.VariationLinks}
                            })
                        }

                        self.saveVariations(updateVariationParams).then(() => {
                            if (UPCCodesToUpdate.length) {
                                self.setState({
                                    currentRecord: {
                                        ...self.state.currentRecord,
                                        'UPCCodes': UPCCodes
                                    }
                                })
                            }
                        })
                    }
                }})                
            },
            modalTitle: 'Confirmation',
            dialogID: 'AddVariantTitleConfirmation'
        })
    }
    renderVariationsAddTagConfirmationDialog() {
        return displayCustomDialog.call(this, {
            cancelButtonTitle: 'No',
            buttonTitle: 'Yes',
            dialogContent: () => {
                return (
                    <div>You are about to remove UPC data, are you sure?</div>
                );
            },
            cancelActionHandler: () => {},
            confirmActionHandler: (data) => {
                const variationIndex = this.state.currentVariationIndex;
                const variation = this.state.currentVariation;

                this.onVariationChange(variationIndex, {
                    ...variation,
                    'AddTag': !variation.AddTag
                })               
            },
            modalTitle: 'Confirmation',
            dialogID: 'AddVariantAddTagConfirmation'
        })        
    }
    renderCurrentRecordVariations() {
        const self = this;
        return _.map(this.state.currentRecord.Variations, function (variation, variationIndex) {
            return <div key={variationIndex} style={{position: 'relative', borderBottom: '1px solid gray'}}
                        className="bot15 pbot10 "><Row   >
                <Col md={2} sm={5} xs={6} className="top10 clearfix">
                    {_.get(variation, 'newVariationOption', 'false') ?

                        <Select
                            clearable={false}
                            placeholder="Type"
                            options={config.GBGProductsVariationTypes}
                            onChange={(option) =>
                                this.onVariationChange(variationIndex, {
                                    ...variation,
                                    Options: [],
                                    Value: '',
                                    'InputType': option.value
                                })
                            }
                            value={variation.InputType}
                        /> :
                        <div
                            className="top5">{_.get(_.find(config.GBGProductsVariationTypes, {value: variation.InputType}), 'label', '')}</div>
                    }
                </Col>
                <Col md={3} sm={5} xs={5} className="top10">
                    <FormControl type="text"
                                 onChange={(e) => {
                                     this.onVariationChange(variationIndex, {...variation,
                                         OriginalLabel:variation.OriginalLabel ? variation.OriginalLabel:variation.Label,
                                         'Label': e.target.value
                                     })
                                 }}
                                 value={variation.Label }
                                 placeholder="Label"/>
                </Col>
                {variation.InputType == 'select' &&
                <Col md={4} sm={4} xs={6} className="top10">

                    <Select
                        clearable={false}
                        multi
                        placeholder=""
                        valueRenderer={this.renderVariationSelectValue.bind(this)}
                        options={getVariationOptions(variation,this.state.currentRecord.sortVariationOptions)}
                        onValueClick={(option) => this.onVariationSelectValueClick(variationIndex, option) }
                        onChange={(options) => {
                            if(options.length==0){
                              return  this.props.displayMessage({
                                    'messageType': 'warning',
                                    'messageCode':'Select variation must have at least one option'
                                });
                            }

                            this.onVariationOptionsChange({variationIndex:variationIndex,options: options, callback:(callbackData)=> {
                                    if( callbackData.deletedOptions.length){
                                        let updateVariationParams = {}
                                        let UPCCodes  = self.getLInkedUPCCodesToUpdate(variation, callbackData.deletedOptions[0], callbackData.deletedOptions[0] ? true:false)
                                        let UPCCodesToUpdate = UPCCodes.filter(item=>{
                                            return item.itemToUpdate
                                        })
                                        if ( UPCCodesToUpdate.length) {
                                            updateVariationParams.UPCCodesToUpdate = UPCCodesToUpdate.map(item=>{
                                                return {recordID:item._id, VariationLinks:item.VariationLinks}
                                            })
                                        }

                                        self.saveVariations(updateVariationParams).then(() => {
                                            if ( UPCCodesToUpdate.length) {
                                                 self.setState({
                                                    currentRecord: {
                                                        ...self.state.currentRecord,
                                                        'UPCCodes': UPCCodes
                                                    }
                                                })
                                             }
                                        })
                                    }
                                }})

                        }}
                        value={_.orderBy(variation.Options, 'label', this.state.currentRecord.sortVariationOptions)}
                    />
                </Col>
                }
                {variation.InputType == 'text' &&
                <Col md={3} sm={3} xs={6} className="top10">

                    <FormControl type="text"
                                 onChange={(e) => {
                                     this.onVariationChange(variationIndex, {...variation, 'Value': e.target.value})
                                 }}
                                 value={variation.Value }
                                 placeholder="Value"/>
                </Col>
                }
                <Col className="pull-left top5">
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <Checkbox
                            onClick={
                                () => {
                                    this.setState({
                                        currentVariationIndex: variationIndex,
                                        currentVariation: variation,
                                        showAddVariantTitleConfirmation:true
                                    })
                                }
                            }
                            checked={variation.UseInTitle}></Checkbox>
                    </OverlayTrigger>
                </Col>
                <Col className="pull-left top5">
                    <OverlayTrigger placement="top" overlay={tooltipAddTag}>
                        <Checkbox
                            onClick={
                                () => {
                                    this.setState({
                                        currentVariationIndex: variationIndex,
                                        currentVariation: variation,
                                        showAddVariantAddTagConfirmation:true
                                    })
                                }
                            }
                            checked={variation.AddTag}></Checkbox>
                    </OverlayTrigger>
                </Col>
                <div style={{position: 'absolute', right: 0,}} className="delete-button top12 right10  "
                     onClick={(e) => {
                         var updateImages = false,
                             GBGProductImagesToUpdate = _.cloneDeep(_.map(_.get(this.state.currentRecord, 'GBGProductImages', [])))

                         _.forEach(_.get(this.state.currentRecord.Variations[variationIndex], 'Options', []), option => {
                             _.forEach(GBGProductImagesToUpdate, image => {
                                 if (_.size(_.get(image, 'ConditionsToMatch', []))) {
                                     image.ConditionsToMatch = _.reject(_.get(image, 'ConditionsToMatch', []), conditionToMatch => {
                                         if (conditionToMatch.Conditions.length == 1) {
                                             if (_.get(conditionToMatch.Conditions, [0, 'VariationLabel']) == _.get(this.state.currentRecord.Variations, [variationIndex, 'Label']) && _.get(conditionToMatch.Conditions, [0, 'OptionValue']) == option.value) {
                                                 updateImages = true;
                                                 return true;
                                             }
                                         }
                                     })
                                 }
                             })
                         })

                         var dataToUpdate = {
                             currentVariationItemIndex:'',
                             currentRecord: {
                                 ...this.state.currentRecord,
                                 Variations: [...this.state.currentRecord.Variations.slice(0, variationIndex),
                                     ...this.state.currentRecord.Variations.slice(variationIndex + 1)],
                             }
                         }
                         if (updateImages) {
                             dataToUpdate.currentRecord.GBGProductImages = GBGProductImagesToUpdate
                         }
                         this.setState(dataToUpdate, ()=>{
                             let updateVariationParams = {}
                             let UPCCodes  = self.getLInkedUPCCodesToUpdate(variation, false, true)
                             let UPCCodesToUpdate = UPCCodes.filter(item=>{
                                 return item.itemToUpdate
                             })
                             if ( UPCCodesToUpdate.length) {
                                 updateVariationParams.UPCCodesToUpdate = UPCCodesToUpdate.map(item=>{
                                     return {recordID:item._id, VariationLinks:item.VariationLinks}
                                 })
                             }

                             self.saveVariations(updateVariationParams).then(() => {
                                 if (UPCCodesToUpdate.length) {
                                     self.setState({
                                         currentRecord: {
                                             ...self.state.currentRecord,
                                             'UPCCodes': UPCCodes
                                         }
                                     })
                                 }
                             })
                         });
                     }}>
                </div>
            </Row>
                {self.displayInputsForVariation(variation,variationIndex)}
            </div>
        }.bind(this))
    }
    displayInputsForVariation(variation,variationIndex){
        const self = this;
         const displaySaveLabelButton =variation.InputType == 'select' && variation.OriginalLabel && variation.Label !== variation.OriginalLabel
        return <Row className="top15   ">
            {displaySaveLabelButton &&
              <Col  xs={3} className=" ">
                  <Button className="  btn btn-primary " type="button"
                          onClick={(e) =>  {
                              let updateVariationParams = {}
                              let UPCCodes = self.getLInkedUPCCodesToUpdate(variation, false, false)
                              let UPCCodesToUpdate = UPCCodes.filter(item => {
                                  return item.itemToUpdate
                              })
                              if (UPCCodesToUpdate.length) {
                                  updateVariationParams.UPCCodesToUpdate = UPCCodesToUpdate.map(item => {
                                      return {recordID: item._id, VariationLinks: item.VariationLinks}
                                  })
                              }
                              self.saveVariations(updateVariationParams).then(() => {
                                  let stateData = {}

                                  self.onVariationChange(variationIndex, {...variation,
                                      OriginalLabel:variation.Label
                                  })
                                  if (UPCCodesToUpdate.length) {
                                      stateData.currentRecord = {
                                          ...self.state.currentRecord,
                                          'UPCCodes': UPCCodes
                                      }
                                  }
                                  self.setState(stateData);
                              })

                          }}>
                      Save Label
                  </Button>
              </Col>

            }
            {variation.InputType == 'select' &&
              <Col xsOffset={0} smOffset={displaySaveLabelButton ? 2 : 5} xs={3} className="pull-left ">
                  <Button className=" right20 pull-left btn btn-primary " type="button"
                          onClick={(e) => this.setState({
                              currentVariationItemIndex: variationIndex,
                              currentVariationOptionIndex: -1,
                              customVariationTypeGBGNote: '',
                              customVariationTypeLabel: '',
                              customVariationTypeValue: ''
                          }) }>
                      Add Option
                  </Button>
              </Col>

            }

        </Row>
    }
    renderVariationSelectOption(option) {
        if (option.CustomGBGNote) {
            var trimmedString = option.GBGNote.replace(/^(.{80}[^\s]*).*/, "$1") + ' ...'
        } else {
            var trimmedString = option.GBGNote.replace(/^(.{80}[^\s]*).*/, "$1")
        }
        // trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))

        return (
            <div>
                <div className="green">{option.Brand}</div>
                <div style={{color: 'orange'}}>{option.Model}</div>
                <div>{option.Category}</div>
                <div>{option.Subcategory}</div>
                <div>{trimmedString}</div>
            </div>
        );
    }

    onVariationChange(variationIndex, updatedVariation, customParams={}) {
        this.setState({
            currentRecord: {
                ...this.state.currentRecord,
                Variations: [...this.state.currentRecord.Variations.slice(0, variationIndex),
                    updatedVariation,
                    ...this.state.currentRecord.Variations.slice(variationIndex + 1)],
            }
        }, ()=>{
            customParams.callback && customParams.callback()
        });
    }

    onSelectAllRecordsChange() {
        if (this.props.adminGBGProducts.selectedProducts.length) {
            this.props.dispatchAction({}, CLEAR_SELECTED_GBG_PRODUCTS)
        } else {
            this.search({include: ['_id'], all: true}).then(response => {
                this.props.dispatchAction(response.data.data, ADD_SELECTED_GBG_PRODUCTS)
            });
        }
    }

    onVariationOptionsChange({variationIndex, options,callback}) {
        let updateImages = false
        let GBGProductImagesToUpdate
        let deletedOptions = []
        if (_.get(this.state.currentRecord.Variations, [variationIndex, 'Options'], []).length > options.length) {/* deleting option*/

              deletedOptions = _.differenceWith(_.get(this.state.currentRecord.Variations, [variationIndex, 'Options'], []), options, function (item1, item2) {

                return item1.value === item2.value
            });
            if (_.size(deletedOptions)) {

                GBGProductImagesToUpdate = _.map(_.get(this.state.currentRecord, 'GBGProductImages', []), image => {
                    if (_.size(_.get(image, 'ConditionsToMatch', []))) {
                        return {
                            ...image,
                            ConditionsToMatch: _.reject(_.get(image, 'ConditionsToMatch', []), conditionToMatch => {
                                if (conditionToMatch.Conditions.length == 1) {
                                    if (_.get(conditionToMatch.Conditions, [0, 'VariationLabel']) == _.get(this.state.currentRecord.Variations, [variationIndex, 'Label']) && _.get(conditionToMatch.Conditions, [0, 'OptionValue']) == deletedOptions[0].value) {
                                        updateImages = true;
                                        return true;
                                    }
                                }

                            })
                        }
                    } else {
                        return image
                    }

                })

            }
        }
        var dataToUpdate = {
            currentRecord: {
                ...this.state.currentRecord,
                Variations: [...this.state.currentRecord.Variations.slice(0, variationIndex),
                    {...this.state.currentRecord.Variations[variationIndex], Options: options},
                    ...this.state.currentRecord.Variations.slice(variationIndex + 1)],
            }
        }
        if (updateImages) {
            dataToUpdate.currentRecord.GBGProductImages = GBGProductImagesToUpdate
        }
        this.setState(dataToUpdate, ()=>{
            if(callback){
                callback({deletedOptions})
            }
        });
    }


    getGBGProductTagsOptions() {
        var filteredGBGProductTags = [], self = this
        _.forEach(this.state.allGBGProductTags, function (item) {
            if (item.conditions.length == 0) {
                filteredGBGProductTags.push(item)
            } else {
                var correctStatements = _.filter(item.conditions, function (condition) {
                    if (_.includes(['category'], condition.field.toLowerCase())) {
                        if (_.find(_.get(self.state.currentRecord, 'Categories', []), function (categoryData) {
                                if (categoryData.Category == condition.value.Category) {
                                    if (condition.value.Subcategory) {
                                        if (_.get(categoryData, 'Subcategory', '') == condition.value.Subcategory) {
                                            return true
                                        }
                                    } else {
                                        return true
                                    }
                                }
                            })) {
                            return true
                        }
                    } else {
                        return !_.isUndefined(config.operatorsMap[condition.operator]) && config.operatorsMap[condition.operator](_.get(self.state.currentRecord, [condition.field]), condition.value)
                    }
                })
                if (item.conditionsOperator == 'or') {

                    if (correctStatements.length) {
                        filteredGBGProductTags.push(item)
                        return true;
                    }
                } else {
                    if (correctStatements.length == item.conditions.length) {
                        filteredGBGProductTags.push(item)
                        return true;
                    }
                }
            }
        })
        return _.orderBy(filteredGBGProductTags, function (item) {
            return item.label
        }, ['asc'])
    }
    displayBoxSizeInput(){
        if(_.get(this.state.currentRecord, 'Brand','').toLowerCase() == 'bundle' ){
            return  null
        }
        var boxSizeTag  =  _.find( _.get(this.state.currentRecord, 'GBGProductTags', []), function (tag) {
            return _.includes(tag.value, 'Box_')   })

        if(_.isUndefined(this.state.currentRecord.boxSizeConfirmed)){
            var  boxSizeConfirmed = _.get(this.state.currentRecord, 'OriginalProductData.OriginalProductCustomData.BoxSizeConfirmed')
        } else {
            var   boxSizeConfirmed = this.state.currentRecord.boxSizeConfirmed
        }


        var boxSizeOptions = _.cloneDeep(config.boxSizeList)
        if (this.state.currentRecord.selectedBoxSize){
            if (!_.find(boxSizeOptions,{value:this.state.currentRecord.selectedBoxSize})) {
                var dimensions = _.split(this.state.currentRecord.selectedBoxSize, 'x')

                var newBoxSizeOption = {
                    label: dimensions[0] + ' x ' + dimensions[1] + ' x ' + dimensions[2],
                    data: {Length: dimensions[0], Width: dimensions[1], Height: dimensions[2]},
                    value: this.state.currentRecord.selectedBoxSize,
                }
                boxSizeOptions.push(newBoxSizeOption)
            }
        }
        boxSizeOptions = _.orderBy(boxSizeOptions,item=>{
            return _.get(item.data, 'Length')
        }, 'asc')

        return        <Row className="bot15 top10">
            <Col  md={8} xs={12} className="top10"  >
                <ControlLabel className=" pull-left top7 right15 ">Box size:</ControlLabel>
                <Select
                    style={{width: 170}}
                    className="pull-left right15"
                    clearable={false}
                    placeholder=""
                    options={boxSizeOptions}
                    onChange={(option) => {
                        var dataToUpdate  = {
                            selectedBoxSize:  option ?option.value:null,
                            resizedBoxHeight:option ? option.data.Height:'',
                            boxSizeConfirmed:false,
                        }
                        dataToUpdate.GBGProductTags = _.clone(_.get(this.state.currentRecord, 'GBGProductTags', []))
                        dataToUpdate.GBGProductTags  =_.reject(  dataToUpdate.GBGProductTags,tag=>{
                            return  _.includes(tag.value, 'Box_')
                        })
                        if (option){

                            dataToUpdate.GBGProductTags.push({
                                label: 'Box_' +option.value,
                                value: 'Box_' +option.value,
                            })
                        }

                        this.setState({
                            currentRecord: {
                                ...this.state.currentRecord,
                                ...dataToUpdate
                            }
                        })

                    }}
                    value={_.get(this.state.currentRecord,'selectedBoxSize','')}
                />

                {boxSizeTag  &&
                <span>
                          {boxSizeConfirmed ? <FaCheckCircle    style={{fontSize: 34, color: 'green'}}></FaCheckCircle> :
                              <TIWarning   style={{fontSize: 34, color: 'red'}}></TIWarning>
                          }

                    <a style={{position: 'relative', top: 2}} className="left15 top7 " onClick={() => {
                        this.setState({
                            'currentRecord': {
                                ...this.state.currentRecord,
                                boxSizeConfirmed: !boxSizeConfirmed
                            }
                        })
                    }  } href='#'>{(  boxSizeConfirmed) ? 'Un-confirm' : 'Confirm'}</a>

                    </span>

                }
            </Col>
            { ( boxSizeTag && !_.includes(boxSizeTag.value,'Mailer')) &&
            <Col  md={4} xs={12} className="top10" >
                <ControlLabel className=" pull-left top7 right15 ">Resize height:</ControlLabel>
                <FormControl type="number"    style={{width: 70}} className="pull-left"

                             onChange={(e) => {

                                 this.setState({
                                     'currentRecord': {
                                         ...this.state.currentRecord,
                                         resizedBoxHeight: e.target.value
                                     }
                                 })
                             }}
                             value={this.state.currentRecord.resizedBoxHeight}
                             placeholder=""/>
            </Col>
            }

        </Row>
    }

    displayMostWantedInput() {
        return [
                <FormGroup className="bot5">
                    <ControlLabel>Most Wanted</ControlLabel>    
                    <hr style={{marginTop: 0, marginBottom: 0}}></hr>
                </FormGroup>
               ,<Row className="bot15 top10">
               <Col  md={7} xs={12} className="top10"  >
                <ControlLabel className="pull-left top7 right15 ">Enable Most Wanted:</ControlLabel>
                <Checkbox
                        onClick={() => {
                            this.setState({
                                'currentRecord': {
                                    ...this.state.currentRecord,
                                    ActiveMostWantedGBGProduct: !this.state.currentRecord.ActiveMostWantedGBGProduct
                                }
                            })
                        }}
                        checked={this.state.currentRecord.ActiveMostWantedGBGProduct}></Checkbox>
                </Col>
                { this.state.currentRecord.ActiveMostWantedGBGProduct && 
                <Col  md={5} xs={12} className="top10"  >
                <ControlLabel className="pull-left top7 right15 ">Seller Payout Percentage:</ControlLabel>
                <FormControl type="number" min="0.1" max="100" style={{width: 70}} className="pull-left"
                        onChange={(e) => {

                            this.setState({
                                'currentRecord': {
                                    ...this.state.currentRecord,
                                    MostWantedProductPayoutPercentage: e.target.value
                                }
                            })
                        }}
                        value={this.state.currentRecord.MostWantedProductPayoutPercentage}
                        placeholder=""/>
                </Col>}
        </Row>]
    }

    render() {
        var self = this;

         const {selectedImage = {}, currentQualityCheckItem = {}, matchingQualityChecks = [], qualityChecksMatchingParams = {}} = this.state.currentRecord;
          return (

            <div >
                {_.size(this.state.allCategories) > 0 &&
                <AdminGBGProductsActionsBox ref="actionsBox"
                                            search={this.search.bind(this)}
                                            getVariationOptions={this.getVariationOptions}

                                            allCategories={this.state.allCategories}
                                            {...this.props} ></AdminGBGProductsActionsBox>
                }
                {_.size(this.state.allCategories) > 0 &&
                <AdminGBGProductSearchBox pending={this.state.pending}
                                          ref={(searchBox) => {
                                              if (searchBox && !this.searchBox) {
                                                  this.searchBox = searchBox
                                                  if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                                                      this.search({page:this.state.currentPage+1})
                                                  }
                                              }

                                          }}
                                          addNewGBGProduct={this.addNewGBGProduct.bind(this)}
                                          onSelectAllRecordsChange={this.onSelectAllRecordsChange.bind(this)}
                                          allCategories={this.state.allCategories}
                                          allBrands={this.state.allBrands}
                                          search={this.search.bind(this)}
                                          {...this.props} ></AdminGBGProductSearchBox>
                }
                {this.props.adminGBGProducts.fetched && _.size(this.state.allCategories) > 0 &&
                <div>
                    {this.props.adminGBGProducts.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'GBG products')}</div> :
                        <div className="top20">

                            <AdminGBGProductListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                allCategories={this.state.allCategories}
                                editRecord={this.editRecord.bind(this)}
                                allGBGProductTags={this.state.allGBGProductTags}
                                search={this.search.bind(this)} {...this.props}  ></AdminGBGProductListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : _.isUndefined(queryString.parse(this.props.location.search).perPage) ? undefined : queryString.parse(this.props.location.search).perPage}
                                ref={'pagination'}
                                total={this.props.adminGBGProducts.total == 'initial' ? 0 : this.props.adminGBGProducts.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }
                <Modal className="custom-modal-dialog"
                       backdrop={ 'static' }
                       keyboard={ false }
                       onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup>
                                <ControlLabel>Categories</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    clearable={false}
                                    multi
                                    placeholder=""
                                    valueRenderer={this.renderCategoriesValue.bind(this)}
                                    removeSelected={false}
                                    options={this.state.currentRecordCategoriesList}
                                    onChange={(options) => this.onCategoryFormChange(options)}
                                    value={this.state.currentRecord.Categories}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Subcategory</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    disabled={_.size(_.get(this.state.currentRecord, ['Categories'], [])) == 0}
                                    clearable={false}
                                    placeholder=""
                                    options={this.state.currentRecordSubcategoriesList}
                                    onChange={(option) => this.onSubcategoryFormChange(option)}
                                    value={this.state.Subcategory}
                                />
                            </FormGroup>
                            <FormGroup className=" bot20">
                                <ControlLabel className="pleft0 col-xs-12  ptop5">Age Groups</ControlLabel>
                                <Select
                                    placeholder="Age groups"
                                    clearable={false}
                                    multi
                                    options={getAllowedAgeGroups()}
                                    onChange={(options) => {
                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                AgeGroups: _.map(options, 'value')
                                            }
                                        })
                                    }}
                                    value={_.get(this.state.currentRecord, ['AgeGroups'], [])}
                                />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Category Tags</ControlLabel>
                                <CreatableSelect
                                    tabIndex="0"
                                    clearable={true}
                                    options={this.state.allCategoryTags}
                                    multi
                                    placeholder="Category Tags"
                                    removeSelected={false}
                                    //options={this.state.currentRecordCategoriesList}
                                    onChange={ (selectedOptions) => {

                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                'CategoryTags': selectedOptions
                                            }
                                        })

                                    }}
                                    value={this.state.currentRecord.CategoryTags}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>GBG Product Tags</ControlLabel>
                                <CreatableSelect
                                    tabIndex="0"
                                    clearable={true}
                                    options={this.getGBGProductTagsOptions()}
                                    multi
                                    placeholder="GBG Product Tags"
                                    removeSelected={false}
                                    //options={this.state.currentRecordCategoriesList}
                                    onChange={ (selectedOptions) => {
                                        var dataToUpdate = {
                                            ...this.state.currentRecord,
                                            latestGBGProductTag: {},
                                        }
                                        if (selectedOptions.length > _.get(this.state.currentRecord, 'GBGProductTags', []).length){
                                            if(_.includes(['Child Age Range', 'Child Weight Range'], _.get(_.last(selectedOptions), 'value'))) {
                                                dataToUpdate.latestGBGProductTag = _.last(selectedOptions)
                                            } else{
                                                dataToUpdate.GBGProductTags = selectedOptions
                                            }
                                        } else {
                                            dataToUpdate.GBGProductTags = selectedOptions


                                            if( _.includes(_.get(_.last(_.get(this.state.currentRecord, 'GBGProductTags', [])),'value'), 'Box_')) {/* if Box_ size tag is removed, clear selectedBoxSize*/
                                                dataToUpdate.selectedBoxSize = null
                                            }

                                        }
                                        var boxSizeTag  =  _.findLast( dataToUpdate.GBGProductTags, function (tag) {
                                            return _.includes(tag.value, 'Box_')   })


                                        if(boxSizeTag) {
                                            if( _.get(this.state.currentRecord, 'Brand','').toLowerCase() == 'bundle' ){
                                                return/* do not allow to add Box_ size tag for bundles*/
                                            }
                                            dataToUpdate.boxSizeConfirmed =false
                                            dataToUpdate.resizedBoxHeight = ''
                                            var boxSizeDimensions =  _.split( boxSizeTag.value.substring(4) ,'x')
                                            if(boxSizeDimensions.length ==3) {
                                                dataToUpdate.GBGProductTags = _.reject(dataToUpdate['GBGProductTags'],tag=>{
                                                    return  _.includes(tag.value, 'Box_')
                                                })
                                                dataToUpdate.GBGProductTags.push(boxSizeTag)
                                                dataToUpdate.selectedBoxSize = boxSizeTag.value.substring(4)
                                                dataToUpdate.resizedBoxHeight = boxSizeDimensions[2]
                                            }


                                        }

                                        this.setState({
                                            currentRecord: dataToUpdate
                                        })

                                    }}
                                    value={this.state.currentRecord.GBGProductTags}
                                />
                            </FormGroup>
                            {_.includes(['Child Age Range', 'Child Weight Range'], _.get(this.state.currentRecord, 'latestGBGProductTag.value')) &&
                            <Row className="bot15">
                                <Col md={4} xs={6} className="top10">
                                    <FormControl type="number" min="0" max="80"
                                                 onChange={(e) => {
                                                     this.setState({
                                                         currentRecord: {
                                                             ...this.state.currentRecord,
                                                             latestGBGProductTag: {
                                                                 ...this.state.currentRecord.latestGBGProductTag,
                                                                 from: e.target.value
                                                             }
                                                         }
                                                     })
                                                 }}
                                                 value={_.get(this.state.currentRecord, 'latestGBGProductTag.from')}
                                                 placeholder={_.get(this.state.currentRecord, 'latestGBGProductTag.label') + ' From'}/>
                                </Col>


                                <Col md={4} xs={6} className="top10">
                                    <FormControl type="number" min="0" max="80"
                                                 onChange={(e) => {
                                                     this.setState({
                                                         currentRecord: {
                                                             ...this.state.currentRecord,
                                                             latestGBGProductTag: {
                                                                 ...this.state.currentRecord.latestGBGProductTag,
                                                                 to: e.target.value
                                                             }
                                                         }
                                                     })
                                                 }}
                                                 value={_.get(this.state.currentRecord, 'latestGBGProductTag.to')}
                                                 placeholder={_.get(this.state.currentRecord, 'latestGBGProductTag.label') + ' To'}/>

                                </Col>
                                <Col md={4} sm={4} xs={6} className="top10">
                                    <Button className="right10 pull-left btn btn-primary "
                                            disabled={!_.get(this.state.currentRecord, 'latestGBGProductTag.from') || !_.get(this.state.currentRecord, 'latestGBGProductTag.to')}
                                            type="button"
                                            onClick={() => {
                                                if (_.get(this.state.currentRecord, 'latestGBGProductTag.from') < 0 || _.get(this.state.currentRecord, 'latestGBGProductTag.from') > 80) {
                                                    return this.props.displayMessage({
                                                        'messageType': 'warning',
                                                        'messageCode': 'From value must be between 0 and 80',
                                                    });
                                                }
                                                if (_.get(this.state.currentRecord, 'latestGBGProductTag.to') < 0 || _.get(this.state.currentRecord, 'latestGBGProductTag.to') > 80) {
                                                    return this.props.displayMessage({
                                                        'messageType': 'warning',
                                                        'messageCode': 'To value must be between 0 and 80',
                                                    });
                                                }
                                                if (_.includes(['Child Age Range', 'Child Weight Range'], _.get(this.state.currentRecord, 'latestGBGProductTag.value'))) {
                                                    var tagAlreadyIncluded = _.find(_.get(this.state.currentRecord, 'GBGProductTags', []), currentTag => {
                                                        if (_.includes('Child Age Range', _.get(this.state.currentRecord, 'latestGBGProductTag.value')) && _.includes(currentTag.value, 'Child Age Range')) {
                                                            return true;
                                                        }
                                                        if (_.includes('Child Weight Range', _.get(this.state.currentRecord, 'latestGBGProductTag.value')) && _.includes(currentTag.value, 'Child Weight Range')) {
                                                            return true;
                                                        }
                                                    })
                                                    if (tagAlreadyIncluded) {
                                                        return this.props.displayMessage({
                                                            'messageType': 'warning',
                                                            'messageCode': 'This type of tag is already included',
                                                        });
                                                    }
                                                }
                                                this.setState({
                                                    currentRecord: {
                                                        ...this.state.currentRecord,
                                                        GBGProductTags: _.concat(_.get(this.state.currentRecord, 'GBGProductTags', []), [{
                                                            value: this.state.currentRecord.latestGBGProductTag.value + '_' + this.state.currentRecord.latestGBGProductTag.from + '-' + this.state.currentRecord.latestGBGProductTag.to,
                                                            label: this.state.currentRecord.latestGBGProductTag.value + '_' + this.state.currentRecord.latestGBGProductTag.from + '-' + this.state.currentRecord.latestGBGProductTag.to,
                                                        }])
                                                    }
                                                })

                                            }
                                            }>
                                        Add tag
                                    </Button>

                                    <Button className="left10 pull-left btn btn-primary " type="button"
                                            onClick={() => this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    latestGBGProductTag: {}
                                                }
                                            }) }>
                                        Cancel
                                    </Button>

                                </Col>

                            </Row>
                            }
                            <FormGroup>
                                <ControlLabel>Brand</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Brand: e.target.value
                                                 }
                                             })}
                                             onFocus={(e) => this.setState({
                                                 errors: {
                                                     ...this.state.errors,
                                                     Brand: false
                                                 }
                                             }) }
                                             value={this.state.currentRecord.Brand }
                                             style={this.state.errors['Brand'] ? {border: '1px solid red'} : {} }
                                             placeholder="Brand"/>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Model</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Model: e.target.value
                                                 }
                                             })}
                                             onFocus={(e) => this.setState({
                                                 errors: {
                                                     ...this.state.errors,
                                                     Model: false
                                                 }
                                             }) }
                                             value={this.state.currentRecord.Model }
                                             style={this.state.errors['Model'] ? {border: '1px solid red'} : {} }
                                             placeholder="Model"/>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    placeholder="Type"
                                    clearable={false}
                                    options={  [{value: 'Public', label: 'Public'}, {value: 'Seller', label: 'Seller'}]}
                                    onChange={(option) => {
                                        this.setState({
                                            'currentRecord': {
                                                ...this.state.currentRecord,
                                                Type: option.value,
                                            }
                                        });
                                    }}
                                    value={this.state.currentRecord.Type}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Note</ControlLabel>
                                <FormControl type="text"
                                             componentClass="textarea"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     GBGNote: e.target.value
                                                 }
                                             })}

                                             value={this.state.currentRecord.GBGNote }
                                             placeholder="Note"/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Custom Note</ControlLabel>
                                <FormControl type="text"
                                             componentClass="textarea"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     CustomNote: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.CustomNote }
                                             placeholder="Custom Note"/>
                            </FormGroup>
                            {!_.isUndefined(_.get(this.state.currentRecord, 'OriginalProductData.ASIN')) &&
                            <div className="bot20 clearfix">
                                <FormGroup>
                                    <div ><ControlLabel>ASIN</ControlLabel></div>

                                    <FormControl style={{width: 250, float: 'left'}} type="text"
                                                 onChange={(e) => this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         ASIN: e.target.value
                                                     }
                                                 })}
                                                 value={this.state.currentRecord.ASIN }
                                                 placeholder="ASIN"/>
                                    <div className=" pull-right ">
                                        <Button className="  btn btn-primary bot10" type="button"
                                                onClick={() => {
                                                    this.setState({
                                                        currentRecord: {
                                                            ...this.state.currentRecord,
                                                            AmazonProductData: false,
                                                        }
                                                    })
                                                    this.getAmazonProductDataByASIN()
                                                } }>
                                            Get Amazon product data by ASIN
                                        </Button>

                                        <div
                                            style={{visibility: _.get(this.state.currentRecord, 'AmazonProductData.ASIN') ? 'visible' : 'hidden'}}>
                                    <span>Amazon    <a target="_blank"
                                                       href={ _.get(this.state.currentRecord, 'AmazonProductData.OriginalUrl') }>product</a> price:</span><span
                                            className="left5 purple">{_.get(this.state.currentRecord, 'AmazonProductData.price')}</span>
                                        </div>

                                    </div>
                                </FormGroup>

                            </div>
                            }

                            <FormGroup>
                                <ControlLabel>Retail Price</ControlLabel>
                                <FormControl style={{width:200}} type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     RetailProductPrice: e.target.value
                                                 }
                                             })}
                                             value={_.get(this.state.currentRecord, 'RetailProductPrice', '') }
                                             placeholder="Retail Price"/>
                            </FormGroup>

                            <Row className="bot15">
                                {!_.isUndefined(_.get(this.state.currentRecord, 'OriginalProductData.ASIN')) &&
                                <Col md={3} sm={3} xs={6} className="top10">
                                    <ControlLabel>Height (in)</ControlLabel>
                                    <FormControl type="text"
                                                 onChange={(e) => this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         Height: e.target.value
                                                     }
                                                 })}
                                                 value={this.state.currentRecord.Height }
                                                 placeholder="Height"/>
                                </Col>
                                }
                                {!_.isUndefined(_.get(this.state.currentRecord, 'OriginalProductData.ASIN')) &&
                                <Col md={3} sm={3} xs={6} className="top10">
                                    <ControlLabel>Width (in)</ControlLabel>
                                    <FormControl type="text"
                                                 onChange={(e) => this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         Width: e.target.value
                                                     }
                                                 })}
                                                 value={this.state.currentRecord.Width }
                                                 placeholder="Width"/>
                                </Col>
                                }
                                {!_.isUndefined(_.get(this.state.currentRecord, 'OriginalProductData.ASIN')) &&
                                <Col md={3} sm={3} xs={6} className="top10">
                                    <ControlLabel>Length (in)</ControlLabel>
                                    <FormControl type="text"
                                                 onChange={(e) => this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         Length: e.target.value
                                                     }
                                                 })}
                                                 value={this.state.currentRecord.Length }
                                                 placeholder="Length"/>
                                </Col>
                                }
                                <Col md={3} sm={3} xs={6} className="top10">
                                    <ControlLabel>Weight (lb)</ControlLabel>
                                    <FormControl type="text"
                                                 onChange={(e) => this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         Weight: e.target.value
                                                     }
                                                 })}
                                                 value={this.state.currentRecord.Weight }
                                                 placeholder="Weight"/>
                                </Col>


                            </Row>
                            {this.displayBoxSizeInput()}


                            {this.displayMostWantedInput()}

                            <FormGroup>
                                <ControlLabel>Quality checks to include</ControlLabel>
                                <Row>
                                    <Col md={10} sm={10} xs={12} className="bot10">
                                        <CreatableSelect
                                            tabIndex="0"
                                            clearable={true}
                                            optionRenderer={this.renderQualityCheckOptions.bind(this)}
                                            options={_.map(_.reject(this.state.allQualityChecks, item => {

                                                return _.includes(_.map(_.get(this.state.currentRecord, 'QualityChecksToExclude', []), 'value'), item.value)
                                            }), item=>{

                                                return {value:item.value, label:item.label, ItemNumber: item.value }
                                            })
                                            }
                                            multi
                                            placeholder=""
                                            removeSelected={false}
                                            //options={this.state.currentRecordCategoriesList}
                                            valueRenderer={this.renderQualityCheckValues.bind(this)}
                                            onValueClick={(option) => this.onQualityChecksToIncludeClick(option) }
                                            onChange={(selectedOptions)=> onQualityChecksToIncludeChange.call(self, selectedOptions)}
                                            value={this.state.currentRecord.QualityChecksToInclude}
                                        />
                                    </Col>
                                    <Col md={2} sm={2} xs={12} className="bot10">
                                        <Button className=" btn btn-primary " type="button"
                                                onClick={() => {

                                                    this.setState({
                                                        currentRecord: {
                                                            ...this.state.currentRecord,
                                                            currentQualityCheckItem: {
                                                                customQualityCheck: true,
                                                                QualityCheckRules: [],
                                                                DeterministicQualityCheck:{
                                                                    Answers: [{
                                                                        AnswerText:'Yes'
                                                                    },{
                                                                        AnswerText:'No'
                                                                    }]
                                                                },
                                                                display: true,
                                                            }
                                                        }
                                                    })
                                                }
                                                }>
                                            Add new
                                        </Button>
                                    </Col>
                                </Row>
                            </FormGroup>
                            {_.get(this.state.currentRecord, 'currentQualityCheckItem.display') &&
                            <Row className="bot15 ">
                                {currentQualityCheckItem.customQualityCheck &&
                                <Col md={4} xs={6} className="top10">
                                    <FormControl type="text"
                                                 onChange={(e) => this.setState({
                                                     currentRecord: {
                                                         ...this.state.currentRecord,
                                                         currentQualityCheckItem: {
                                                             ..._.get(this.state.currentRecord, 'currentQualityCheckItem', {}),
                                                             label: e.target.value
                                                         }
                                                     }
                                                 })}
                                                 value={_.get(this.state.currentRecord, 'currentQualityCheckItem.label', '') }
                                                 placeholder="Text"/>
                                </Col>
                                }
                                {currentQualityCheckItem.customQualityCheck &&
                                  <Col md={12} sm={12} xs={12} className=" top10" >
                                      <ControlLabel className="bot0">Answers</ControlLabel>
                                      <QualityCheckAnswerList
                                        displayMessage={this.props.displayMessage}
                                        updateState={data => {
                                            self.setState({
                                                currentRecord:{
                                                    ...self.state.currentRecord,
                                                    currentQualityCheckItem:data.currentRecord
                                                }
                                            });
                                        }}
                                        currentRecord={this.state.currentRecord.currentQualityCheckItem}>
                                      </QualityCheckAnswerList>
                                      <div className="clearfix"></div>
                                      <FormGroup>
                                          <Checkbox
                                            onChange={(e) => {
                                                const {DeterministicQualityCheck = {}} = this.state.currentRecord.currentQualityCheckItem;
                                                this.setState({
                                                    'currentRecord': {
                                                        ...this.state.currentRecord,
                                                        currentQualityCheckItem: {
                                                            ...this.state.currentRecord.currentQualityCheckItem,
                                                            DeterministicQualityCheck: {
                                                                ...DeterministicQualityCheck,
                                                                Type: DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.ShowFirst ? undefined : config.deterministicQualityCheckTypes.ShowFirst
                                                            }
                                                        }
                                                    }
                                                });
                                            }}
                                            checked={ (function () {
                                                const {DeterministicQualityCheck = {}} = self.state.currentRecord.currentQualityCheckItem;
                                                return DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.ShowFirst;
                                            })()
                                            }><span className="top10">Show first</span></Checkbox>
                                      </FormGroup>
                                  </Col>
                                }

                                <Col md={12} sm={12} xs={12} className="top10">
                                    {currentQualityCheckItem.customQualityCheck &&
                                      <Button className="right10 pull-left btn btn-primary " type="button"
                                              disabled={_.get(this.state.currentRecord, 'currentQualityCheckItem.customQualityCheck') && !_.get(this.state.currentRecord, 'currentQualityCheckItem.label', '')}
                                              onClick={() => {
                                                  updateCurrentQualityCheckToInclude.call(this);
                                              }}>
                                          {currentQualityCheckItem.value ? 'Update' : 'Add'}
                                      </Button>
                                    }
                                    {this.state.currentRecord.currentQualityCheckItem.ItemNumber &&
                                      <Button className="right10 pull-left btn btn-primary " type="button"
                                              onClick={() => {
                                                  const serverURL = config.getEnvironmentName() == 'local' ? config.getEnvironment().clientSideURL : config.getEnvironment().directServerBaseURL;
                                                  const link = `${serverURL}/admin/quality-checks?ItemNumbers=${encodeURIComponent(this.state.currentRecord.currentQualityCheckItem.ItemNumber)}&openEditForm=true`;
                                                  window.open(link, '_blank');
                                              }}>
                                          Edit Quality Check
                                      </Button>
                                    }
                                    {selectedImage._id && displayButtonToLinkQualityCheckToImage.call(self)}
                                 </Col>

                            </Row>
                            }


                            <FormGroup>
                                <ControlLabel>Quality checks to exclude</ControlLabel>
                                <CreatableSelect
                                    tabIndex="0"
                                    clearable={true}
                                    optionRenderer={this.renderQualityCheckOptions.bind(this)}
                                    options={_.map(_.reject(this.state.allQualityChecks, item => {
                                        return _.includes(_.map(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), 'value'), item.value)
                                    }), item=>{

                                        return {value:item.value, label:item.label, ItemNumber: item.value }
                                    })
                                    }
                                    multi
                                    valueRenderer={this.renderQualityCheckValues.bind(this)}
                                    placeholder=""
                                    removeSelected={false}
                                    //options={this.state.currentRecordCategoriesList}
                                    onChange={ (selectedOptions) => {
                                        var selectedOptionsCopy = _.map(selectedOptions, item => {
                                            if(item.className){
                                                item.customQualityCheck = true
                                            }
                                            return  item
                                        })
                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                'QualityChecksToExclude': selectedOptionsCopy
                                            }
                                        })

                                    }}
                                    value={this.state.currentRecord.QualityChecksToExclude}
                                />
                            </FormGroup>

                            <div className="bot20 clearfix">
                                <div className=" ">
                                    <Button className="pull-right btn btn-primary bot10" type="button"
                                            onClick={() => {
                                                this.setState({
                                                    currentRecord: {
                                                        ...this.state.currentRecord,
                                                        AmazonProductData: false,
                                                    }
                                                });
                                                this.getQualityChecksForGBGProduct();
                                            } }>
                                        Display quality checks matched by rules
                                    </Button>
                                    {matchingQualityChecks.length > 0 &&
                                     <div className=" clearfix"
                                          style={{visibility: this.props.appData.FeatureFlags.AllowOrderQualityChecks && !_.isEmpty(qualityChecksMatchingParams)  ? 'visible' :  'hidden'}}>
                                         {this.props.appData.FeatureFlags.AllowOrderQualityChecks ?
                                     <GBGProductQualityChecksComponent updateParentComponentState={(dataToUpdate) => {
                                           this.setState(dataToUpdate);
                                     }}
                                                       displayContentForQualityCheck={(item)=>{
                                                            return displayQualityCheckItemImages.call(self, item);
                                                        }}
                                         currentRecord={this.state.currentRecord}></GBGProductQualityChecksComponent> : null}
                                     </div>
                                    }
                                    <div className=" clearfix"
                                         style={{visibility: !this.props.appData.FeatureFlags.AllowOrderQualityChecks && !_.isEmpty(_.get(this.state.currentRecord, 'qualityChecksMatchingParams',{}))  ?  'visible' : 'hidden'}}>
                                        {_.map(_.get(this.state.currentRecord, 'matchingQualityChecks'), function (item, index) {
                                            var itemToInclude = _.find(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), itemToInclude => {
                                                return _.get(itemToInclude, 'value') == item.ItemNumber
                                            })
                                            var secondaryText = '',ruleStyling={}
                                            if (_.size(_.get(itemToInclude,'QualityCheckRules',[]))){
                                                secondaryText =' overriden'
                                                ruleStyling = {'text-decoration': 'line-through'}
                                            }
                                            var matchingRules = _.map(_.filter(_.get(item, 'Rules', []), {
                                                Type: 'Matching',
                                                Field: 'Price'
                                            }),rule=>{
                                                return {ruleStyling:ruleStyling, Text: rule.Field +  ' ' + rule.Operator  +' ' +(rule.Field == 'Price'? '$'+ rule.Value : rule.Value),secondaryText:secondaryText}
                                            })
                                            matchingRules =_.concat(matchingRules,_.map(_.intersection(_.get(item,'CategoryTags',[]),_.map(_.get(this.state.currentRecord, 'qualityChecksMatchingParams.CategoryTags', []))),tag=> {
                                                return  { Text: 'Category Tag = '+ tag}
                                            } ))
                                            _.forEach(_.get(this.state.currentRecord, 'qualityChecksMatchingParams.Categories', []), function (categoryData) {
                                                if (_.size(_.get(item, 'Categories', [])) > 0) {
                                                    _.forEach(_.get(item, 'Categories', []), function (qualityCheckCategoryData) {
                                                        if (qualityCheckCategoryData.Category == categoryData.Category) {
                                                            if (qualityCheckCategoryData.Subcategory) {
                                                                if (categoryData.Subcategory) {
                                                                    if (categoryData.Subcategory == qualityCheckCategoryData.Subcategory) {
                                                                        matchingRules.push(
                                                                            { Text: 'Category and Subcategory = '+ categoryData.Category + ' and ' + categoryData.Subcategory}
                                                                        )
                                                                    }
                                                                }
                                                                /* if there is no Subcategory to check in parameters, we do not match items with Subcategories, even if Category matches*/
                                                            } else {
                                                                matchingRules.push(
                                                                    { Text: 'Category = '+ categoryData.Category}
                                                                )
                                                                /* if there is no Subcategory in quality check item, it is matched only by Category */
                                                            }
                                                        }

                                                    })
                                                }
                                            })
                                            if (_.get(this.state.currentRecord, 'qualityChecksMatchingParams.Brand')) {
                                                if (_.size(_.get(item, 'Models', [])) > 0) {
                                                    _.forEach(_.get(item, 'Models', []), function (qualityCheckModelData) {
                                                        if (qualityCheckModelData.Brand == _.get(self.state.currentRecord, 'qualityChecksMatchingParams.Brand')) {
                                                            if (qualityCheckModelData.Model) {
                                                                if (_.get(self.state.currentRecord, 'qualityChecksMatchingParams.Model')) {
                                                                    if (_.get(self.state.currentRecord, 'qualityChecksMatchingParams.Model') == qualityCheckModelData.Model) {
                                                                        matchingRules.push(
                                                                            { Text: 'Brand and Model = '+ qualityCheckModelData.Brand + ' and ' + qualityCheckModelData.Model}
                                                                        )
                                                                    }
                                                                } else {
                                                                    matchingRules.push(
                                                                        { Text: 'Brand = '+ qualityCheckModelData.Brand}
                                                                    )
                                                                    /* if there is no Model to check, we match all quality check only by a Brand */
                                                                }
                                                            } else {
                                                                matchingRules.push(
                                                                    { Text: 'Brand = '+ qualityCheckModelData.Brand}
                                                                )
                                                                /* if there is no Model in quality check item, it is matched only by Brand */
                                                            }
                                                        }

                                                    })
                                                }
                                            }
                                            var itemToExclude = _.find(_.get(this.state.currentRecord, 'QualityChecksToExclude', []), itemToExclude => {
                                                return _.get(itemToExclude, 'value') == item.ItemNumber
                                            })

                                            matchingRules =_.concat(matchingRules,_.map( _.get(itemToInclude,'QualityCheckRules',[]),rule=> {
                                                return {Text: rule.Field +  ' ' + rule.Operator  +' ' +(rule.Field == 'Price'? '$'+ rule.Value : rule.Value), secondaryText:' (only for this GBG Product)'}
                                            }))
                                            return <Row style={{}} className="" key={index}>
                                                {item.ItemNumber &&
                                                <Col className="pull-left pleft15 top2">
                                                    <OverlayTrigger placement="top"
                                                                    overlay={ <Tooltip className="in" id="tooltip-top">
                                                                        Exclude
                                                                    </Tooltip>}>
                                                        <Checkbox
                                                            onChange={() => {
                                                                var dataToUpdate = {}
                                                                if (itemToExclude) {
                                                                    var foundIndex = _.findIndex(_.get(this.state.currentRecord, 'QualityChecksToExclude', []), object => {
                                                                        return object.value == itemToExclude.value
                                                                    })
                                                                    if (foundIndex !== -1) {
                                                                        dataToUpdate.QualityChecksToExclude = [..._.get(this.state.currentRecord, 'QualityChecksToExclude', []).slice(0, foundIndex),
                                                                            ..._.get(this.state.currentRecord, 'QualityChecksToExclude', []).slice(foundIndex + 1)];
                                                                    }
                                                                } else {
                                                                    dataToUpdate.QualityChecksToExclude = _.concat(_.get(this.state.currentRecord, 'QualityChecksToExclude', []), [{
                                                                        value: item.ItemNumber,
                                                                        'label': item.Text
                                                                    }])
                                                                }
                                                                if (itemToInclude) {
                                                                    var foundIndex = _.findIndex(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), object => {
                                                                        return object.value == itemToInclude.value
                                                                    })
                                                                    if (foundIndex !== -1) {
                                                                        dataToUpdate.QualityChecksToInclude = [..._.get(this.state.currentRecord, 'QualityChecksToInclude', []).slice(0, foundIndex),
                                                                            ..._.get(this.state.currentRecord, 'QualityChecksToInclude', []).slice(foundIndex + 1)];
                                                                    }
                                                                }
                                                                this.setState({
                                                                    currentRecord: _.extend({
                                                                        ...this.state.currentRecord,
                                                                    }, dataToUpdate)
                                                                })
                                                            }}

                                                            checked={itemToExclude ? true : false}></Checkbox>
                                                    </OverlayTrigger>
                                                </Col>
                                                }
                                                <Col xs={10}
                                                     style={itemToExclude ? {'text-decoration': 'line-through'} : {}}
                                                     className={classNames('top12', {'green': itemToInclude},{'left25': !item.ItemNumber}, {'pleft25': !item.ItemNumber},{'red': itemToExclude})}> {item.Text }
                                                    {item.ItemNumber ?
                                                      <span className="left10 orange font-size-16 cursor-pointer underlineText"
                                                            onClick={()=>{
                                                                const serverURL = config.getEnvironmentName() == 'local' ? config.getEnvironment().clientSideURL : config.getEnvironment().directServerBaseURL;
                                                                const link = `${serverURL}/admin/quality-checks?ItemNumbers=${encodeURIComponent(item.ItemNumber)}&openEditForm=true`;
                                                                window.open(link, '_blank');
                                                            }}
                                                      >{`#${item.ItemNumber}`}</span> :
                                                      <span
                                                        className="orange">{' only for this GBG Product'}</span>
                                                    }
                                                    {_.map(matchingRules,  (rule,index)  => {

                                                        return <div
                                                            style={_.get(rule, 'ruleStyling', {})}
                                                            className="purple" key={index} >&#8226; {rule.Text}<span className="orange">{_.get(rule,'secondaryText','')}</span></div>
                                                    })}

                                                </Col>
                                                {this.state.currentRecord._id &&
                                                  displayQualityCheckItemImages.call(self, item)
                                                }


                                            </Row>

                                        }.bind(this))}
                                    </div>
                                </div>
                            </div>
                            {this.state.currentRecord._id &&
                              this.renderCurrentRecordUPCCodes()
                            }

                            <FormGroup>
                                <ControlLabel>Variations:</ControlLabel>

                                {this.renderVariationsUseInTitleConfirmationDialog()}
                                {this.renderVariationsAddTagConfirmationDialog()}
                                {this.renderCurrentRecordVariations()}
                                {this.state.currentVariationItemIndex !== '' &&  displayVariationOptionEditForm.call(self,{}) }
                            </FormGroup>
                            <Row className="left0 top20">
                                <Col md={12} sm={12} xs={12} className="pleft0">
                                    <Button className=" right0 pull-left btn btn-primary " type="button"
                                            onClick={this.addVariation.bind(this) }>
                                        Add Variation
                                    </Button>
                                    <div className="pull-right">{displayVariationsSortingToggle(
                                          this.state.currentRecord.sortVariationOptions,
                                         ()=>{
                                            self.setState({
                                                currentRecord: {
                                                    ...self.state.currentRecord,
                                                    sortVariationOptions: self.state.currentRecord.sortVariationOptions == 'desc' ? 'asc':'desc',
                                                }
                                            });
                                        }
                                      )}</div>

                                </Col>
                            </Row>
                            {this.state.currentRecord._id &&
                              <Row className="left0 top20">
                                  <Col md={12} sm={12} xs={12} className="pleft0">
                                      <ImageList
                                        {...this.props}
                                        currentRecord={this.state.currentRecord}
                                        model={'gbg_products'}
                                        deleteImage={(imageToDelete) => {

                                            this.deleteImage(imageToDelete)
                                            return Promise.resolve(true)
                                        }}
                                        onImageSelect={(image) => {
                                            if (_.get(this.state.currentRecord, 'selectedImage._id') == image._id) {
                                                image = {}
                                            }
                                            this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    selectedImage: image
                                                }
                                            })
                                        }}
                                        selectedImage={_.get(this.state.currentRecord, 'selectedImage')}
                                        displayCustomContent={(image) => {
                                            return <div>
                                                {_.map(_.get(image, 'ConditionsToMatch', []), (item, index) => {
                                                    const firstItemCondition = item.Conditions ? item.Conditions[0] : {}
                                                    let linkedItemLabel = `${firstItemCondition.VariationLabel} - ${firstItemCondition.OptionValue}`
                                                    if (firstItemCondition.QualityCheckNumber) {
                                                        linkedItemLabel = `#${firstItemCondition.QualityCheckNumber}`
                                                    } else if (firstItemCondition.QualityCheckText) {

                                                        const {QualityChecksToInclude = []} = this.state.currentRecord;
                                                        const foundItem = QualityChecksToInclude.find(item => {

                                                            return item.label == firstItemCondition.QualityCheckText
                                                        })
                                                        linkedItemLabel = foundItem ? foundItem.label : 'n/a'
                                                    }
                                                    return <div style={{
                                                        position: 'relative',
                                                        maxWidth: 200,
                                                        borderTop: '1px solid gray'
                                                    }} className="top10 ptop10 pright25" key={index}>{linkedItemLabel}
                                                        {_.get(this.state.currentRecord, 'selectedImage._id') == image._id &&
                                                          <div style={{position: 'absolute', top: 12, right: 0}}
                                                               className="delete-button   "
                                                               onClick={(e) => {
                                                                   e.stopPropagation()
                                                                   var foundItemIndex = _.findIndex(this.state.currentRecord.GBGProductImages, function (image) {
                                                                       return image._id == _.get(this.state.currentRecord, 'selectedImage._id')
                                                                   }.bind(this))
                                                                   var updatedImage = {
                                                                       ...this.state.currentRecord.GBGProductImages[foundItemIndex],
                                                                       ConditionsToMatch: [...this.state.currentRecord.GBGProductImages[foundItemIndex].ConditionsToMatch.slice(0, index),
                                                                           ...this.state.currentRecord.GBGProductImages[foundItemIndex].ConditionsToMatch.slice(index + 1)]
                                                                   }
                                                                   this.setState({
                                                                       currentRecord: {
                                                                           ...this.state.currentRecord,
                                                                           GBGProductImages: [...this.state.currentRecord.GBGProductImages.slice(0, foundItemIndex),
                                                                               updatedImage,
                                                                               ...this.state.currentRecord.GBGProductImages.slice(foundItemIndex + 1)]
                                                                       }
                                                                   })
                                                               }
                                                               }>
                                                          </div>
                                                        }
                                                    </div>
                                                })
                                                }
                                            </div>
                                        }}
                                        uploadImagesSuccess={(uploadedImages) => {
                                            this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    GBGProductImages: _.concat(_.get(this.state.currentRecord, 'GBGProductImages', []), uploadedImages)
                                                }
                                            }, function () {
                                                this.search()
                                            })
                                        }}
                                        images={_.get(this.state.currentRecord, 'GBGProductImages', [])}></ImageList>
                                  </Col>
                              </Row>
                            }
                        </Form>
                    </Modal.Body >
                    < Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button data-testid='form-submit-button' className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.setGBGProductAsDeleted() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminGBGProducts: state.adminGBGProducts,
        appData:state.appData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(AdminGBGProductsPage));